// Do not edit directly, this file was auto-generated.

export default {
  IDSmetadata: {
    exportTimestamp: 'Tue, 21 Apr 2026 23:42:57 GMT',
    figmaLastUpdated: 'Tue, 21 Apr 2026 23:27:32 GMT',
    format: 'javascript-esm-react',
    measurementUnits: 'px',
    relatedThemeName: 'IDS Web Dark',
    styleDictionaryVersion: '4.4.0',
    targetPlatform: 'desktop',
    themeName: 'IDS Web Responsive',
    tokensetVersion: '1.49.0',
    typographySetName: 'functionalTypography-Core',
  },
  accordion: {
    default: {
      color: {
        body: {
          background: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          text: {
            disabled: 'rgba(77,77,77,0.48)',
            enabled: '#333333',
            focus: '#333333',
            hover: '#1a1a1a',
            pressed: '#0d0d0d',
          },
        },
        decorative: {
          accent: '#cc0077',
          decorative1: '#250056',
          decorative2: '#ff9300',
          decorative3: '#df216d',
          decorative4: '#0768fd',
          decorative5: '#9e54b0',
          error: '#bd0100',
          neutral: '#4d4d4d',
          success: '#027815',
          warning: '#f4c65a',
        },
        divider: {
          disabled: 'rgba(230,230,230,0.48)',
          enabled: '#e6e6e6',
          focus: '#e6e6e6',
          hover: '#d9d9d9',
          pressed: '#cccccc',
        },
        expanded: {
          background: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#eaecf6',
            pressed: '#dfe3f1',
          },
        },
        header: {
          collapsed: {
            background: {
              disabled: 'rgba(246,247,251,0.48)',
              enabled: '#f6f7fb',
              focus: '#f6f7fb',
              hover: '#eaecf6',
              pressed: '#dfe3f1',
            },
          },
          text: {
            disabled: 'rgba(77,77,77,0.48)',
            enabled: '#333333',
            focus: '#333333',
            hover: '#1a1a1a',
            pressed: '#0d0d0d',
          },
        },
        sublabel: {
          disabled: 'rgba(77,77,77,0.48)',
          enabled: '#4d4d4d',
          focus: '#4d4d4d',
          hover: '#333333',
          pressed: '#1a1a1a',
        },
      },
      radius: {
        body: '0',
        header: '0',
      },
      spacing: {
        expandCollapseAllGap: {
          groupGap: '16px',
        },
        small: {
          collapsed: {
            min: {
              height: '48px',
              width: '320px',
            },
            padding: {
              bottom: '8px',
              gap: '8px',
              left: '8px',
              right: '12px',
              top: '8px',
            },
          },
          expanded: {
            body: {
              min: {
                height: '48px',
                width: '320px',
              },
              padding: {
                bottom: '8px',
                gap: '24px',
                left: '36px',
                right: '12px',
                top: '4px',
              },
            },
            header: {
              min: {
                height: '48px',
                width: '320px',
              },
              padding: {
                bottom: '8px',
                gap: '8px',
                left: '8px',
                right: '12px',
                top: '8px',
              },
            },
            min: {
              height: '64px',
              width: '320px',
            },
          },
        },
        standard: {
          collapsed: {
            min: {
              height: '48px',
              width: '320px',
            },
            padding: {
              bottom: '12px',
              gap: '8px',
              left: '8px',
              right: '12px',
              top: '12px',
            },
          },
          expanded: {
            body: {
              min: {
                height: '48px',
                width: '320px',
              },
              padding: {
                bottom: '16px',
                gap: '24px',
                left: '36px',
                right: '12px',
                top: '8px',
              },
            },
            header: {
              min: {
                height: '48px',
                width: '320px',
              },
              padding: {
                bottom: '12px',
                gap: '8px',
                left: '8px',
                right: '12px',
                top: '12px',
              },
            },
            min: {
              height: '64px',
              width: '320px',
            },
          },
        },
      },
    },
  },
  autocomplete: {
    default: {
      padding: {
        small: {
          horizontalGap: '4px',
          verticalGap: '0',
        },
        standard: {
          horizontalGap: '4px',
          verticalGap: '4px',
        },
      },
    },
    error: {
      padding: {
        small: {
          horizontalGap: '4px',
          verticalGap: '0',
        },
        standard: {
          horizontalGap: '4px',
          verticalGap: '4px',
        },
      },
    },
  },
  avatar: {
    default: {
      color: {
        background: '#e6e6e6',
        border: {
          enabled: '#808080',
          focus: '#808080',
          hover: '#0557d5',
          pressed: '#013d98',
        },
        content: '#333333',
        focusOutline: '#001433',
        hover: 'rgba(0,0,0,0)',
        hoverOutline: '#0557d5',
      },
      radius: '9999px',
      sizing: {
        large: '64px',
        medium: '48px',
        small: '32px',
        xl: '120px',
        xs: '24px',
      },
    },
  },
  badge: {
    default: {
      color: {
        background: {
          accent: '#cc0077',
          brand: '#0557d5',
          decorative1: '#250056',
          decorative2: '#ff9300',
          decorative3: '#df216d',
          decorative4: '#0768fd',
          decorative5: '#9e54b0',
          default: {
            accent: '#cc0077',
            brand: '#0557d5',
            decorative1: '#250056',
            decorative2: '#ff9300',
            decorative3: '#df216d',
            decorative4: '#0768fd',
            decorative5: '#9e54b0',
            neutral: '#4d4d4d',
          },
          dot: '#cc0077',
          inverse: {
            accent: '#ffe5f4',
            brand: '#ecf4ff',
            decorative1: '#f0e5ff',
            decorative2: '#fff4e5',
            decorative3: '#fce9f0',
            decorative4: '#e6f0ff',
            decorative5: '#f5eef7',
            neutral: '#ffffff',
            neutralInverse: '#ffffff',
          },
          neutral: '#ffffff',
          neutralInverse: '#4d4d4d',
          pill: '#cc0077',
        },
        border: {
          default: '#0d0d0d',
          defaultInverse: '#ffffff',
        },
        label: {
          default: '#0d0d0d',
          defaultInverse: '#ffffff',
          pill: '#ffffff',
        },
      },
      radius: {
        dot: '9999px',
        pill: '9999px',
      },
      spacing: {
        standard: {
          min: {
            dotHeight: '20px',
            dotWidth: '20px',
            pillHeight: '20px',
            pillWidth: '20px',
          },
          padding: {
            bottom: '2px',
            left: '4px',
            right: '4px',
            top: '2px',
          },
        },
      },
    },
  },
  banner: {
    default: {
      color: {
        background: '#4d4d4d',
        icon: '#ffffff',
        text: '#ffffff',
        textLink: {
          disabled: {
            icon: 'rgba(255,255,255,0.48)',
            text: 'rgba(255,255,255,0.48)',
          },
          enabled: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          focused: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          hover: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          outline: '#ecf4ff',
          pressed: {
            icon: '#ffffff',
            text: '#ffffff',
          },
        },
      },
      radius: '0',
      sizing: {
        icon: {
          height: '16px',
          width: '16px',
        },
        max: {
          text: '1200px',
        },
        min: {
          height: '48px',
        },
      },
      spacing: {
        padding: {
          bottom: '8px',
          gap: '8px',
          icon: {
            bottom: '4px',
            gap: '0',
            left: '0',
            right: '0',
            top: '4px',
          },
          left: '16px',
          right: '16px',
          top: '8px',
        },
      },
    },
    error: {
      color: {
        background: '#bd0100',
        icon: '#ffffff',
        text: '#ffffff',
        textLink: {
          disabled: {
            icon: 'rgba(255,255,255,0.48)',
            text: 'rgba(255,255,255,0.48)',
          },
          enabled: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          focused: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          hover: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          outline: '#ecf4ff',
          pressed: {
            icon: '#ffffff',
            text: '#ffffff',
          },
        },
      },
      radius: '0',
      sizing: {
        icon: {
          height: '16px',
          width: '16px',
        },
        max: {
          text: '1200px',
        },
        min: {
          height: '48px',
        },
      },
      spacing: {
        padding: {
          bottom: '8px',
          gap: '8px',
          icon: {
            bottom: '4px',
            gap: '0',
            left: '0',
            right: '0',
            top: '4px',
          },
          left: '16px',
          right: '16px',
          top: '8px',
        },
      },
    },
    warning: {
      color: {
        background: '#926b00',
        icon: '#ffffff',
        text: '#ffffff',
        textLink: {
          disabled: {
            icon: 'rgba(77,77,77,0.48)',
            text: 'rgba(77,77,77,0.48)',
          },
          enabled: {
            icon: '#333333',
            text: '#333333',
          },
          focused: {
            icon: '#333333',
            text: '#333333',
          },
          hover: {
            icon: '#1a1a1a',
            text: '#1a1a1a',
          },
          outline: '#001433',
          pressed: {
            icon: '#0d0d0d',
            text: '#0d0d0d',
          },
        },
      },
      radius: '0',
      sizing: {
        icon: {
          height: '16px',
          width: '16px',
        },
        max: {
          text: '1200px',
        },
        min: {
          height: '48px',
        },
      },
      spacing: {
        padding: {
          bottom: '8px',
          gap: '8px',
          icon: {
            bottom: '4px',
            gap: '0',
            left: '0',
            right: '0',
            top: '4px',
          },
          left: '16px',
          right: '16px',
          top: '8px',
        },
      },
    },
  },
  blade: {
    default: {
      color: {
        border: {
          disabled: 'rgba(128,128,128,0.48)',
          enabled: '#808080',
          hover: '#013d98',
          iconButton: {
            disabled: 'rgba(128,128,128,0.48)',
            enabled: '#808080',
          },
          nonscrolling: {
            disabled: 'rgba(230,230,230,0.48)',
            enabled: '#cccccc',
            hover: '#013d98',
            pressed: '#012865',
          },
          pressed: '#012865',
          scrolling: {
            disabled: 'rgba(230,230,230,0.48)',
            enabled: '#cccccc',
            hover: '#013d98',
            pressed: '#012865',
          },
        },
        borderDefault: '#808080',
        button: {
          enabled: '#0557d5',
          focus: '#001433',
          hover: '#013d98',
          pressed: '#012865',
        },
        container: {
          default: '#ffffff',
          enabled: 'rgba(5,87,213,0)',
          hover: 'rgba(5,87,213,0.08)',
          pressed: 'rgba(5,87,213,0.16)',
        },
        content: {
          copy: '#333333',
          label: '#333333',
          sublabel: '#333333',
        },
        copy: '#333333',
        label: '#333333',
        sublabel: '#333333',
      },
      sizing: {
        GapMedium: '8px',
        GapSmall: '8px',
        MaxWidthCollapsed: '32px',
        MinWidthExpanded: '320px',
        PaddingHorizontal: '24px',
        PaddingLabelsBottom: '2px',
        PaddingVertical: '16px',
      },
      spacing: {
        GapLarge: '24px',
        GapMedium: '16px',
        GapSmall: '8px',
        PaddingHorizontal: '24px',
        PaddingTitlesBottom: '2px',
        PaddingVertical: '16px',
      },
    },
  },
  breadcrumbs: {
    default: {
      color: {
        current: '#333333',
        separator: '#4d4d4d',
      },
      sizing: {
        separator: {
          height: '12px',
          width: '12px',
        },
      },
      spacing: {
        padding: {
          gap: '4px',
        },
      },
    },
  },
  button: {
    default: {
      color: {
        discreet: {
          background: {
            disabled: 'rgba(5,87,213,0)',
            enabled: 'rgba(5,87,213,0)',
            focus: 'rgba(5,87,213,0)',
            hover: 'rgba(5,87,213,0.08)',
            pressed: 'rgba(5,87,213,0.16)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(5,87,213,0.48)',
            enabled: '#0557d5',
            focus: '#0557d5',
            hover: '#013d98',
            pressed: '#012865',
          },
        },
        outline: '#001433',
        primary: {
          background: {
            disabled: 'rgba(5,87,213,0.48)',
            enabled: '#0557d5',
            focus: '#0557d5',
            hover: '#013d98',
            pressed: '#012865',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          outline: '#001433',
          shadow: {
            enabled: 'rgba(5,87,213,0.32)',
            hover: 'rgba(1,61,152,0.32)',
            pressed: 'rgba(1,40,101,0.32)',
          },
        },
        secondary: {
          background: {
            disabled: 'rgba(5,87,213,0)',
            enabled: 'rgba(5,87,213,0)',
            focus: 'rgba(5,87,213,0)',
            hover: 'rgba(5,87,213,0.08)',
            pressed: 'rgba(5,87,213,0.16)',
          },
          border: {
            disabled: 'rgba(128,128,128,0.48)',
            enabled: '#808080',
            focus: '#808080',
            hover: '#013d98',
            pressed: '#012865',
          },
          content: {
            disabled: 'rgba(5,87,213,0.48)',
            enabled: '#0557d5',
            focus: '#0557d5',
            hover: '#013d98',
            pressed: '#012865',
          },
        },
        tertiary: {
          background: {
            disabled: 'rgba(230,230,230,0.48)',
            enabled: '#e6e6e6',
            focus: '#e6e6e6',
            hover: 'rgba(5,87,213,0.08)',
            pressed: 'rgba(5,87,213,0.16)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(5,87,213,0.48)',
            enabled: '#0557d5',
            focus: '#0557d5',
            hover: '#013d98',
            pressed: '#012865',
          },
        },
      },
      radius: {
        small: {
          discreet: '4px',
          primary: '4px',
          secondary: '4px',
          tertiary: '4px',
        },
        standard: {
          discreet: '4px',
          primary: '4px',
          secondary: '4px',
          tertiary: '4px',
        },
      },
      shadow: {
        blur: '6px',
        spread: '-2px',
        x: '0',
        y: '6px',
      },
      shadowPressed: {
        blur: '4px',
        spread: '-1px',
        x: '0',
        y: '4px',
      },
      spacing: {
        small: {
          discreet: {
            min: {
              height: '20px',
              width: '20px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '32px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '32px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '32px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
        },
        standard: {
          discreet: {
            min: {
              height: '20px',
              width: '20px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
        },
      },
    },
    error: {
      color: {
        discreet: {
          background: {
            disabled: 'rgba(189,1,0,0)',
            enabled: 'rgba(189,1,0,0)',
            focus: 'rgba(189,1,0,0)',
            hover: 'rgba(189,1,0,0.08)',
            pressed: 'rgba(189,1,0,0.16)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(189,1,0,0.48)',
            enabled: '#bd0100',
            focus: '#bd0100',
            hover: '#990000',
            pressed: '#660000',
          },
        },
        outline: '#001433',
        primary: {
          background: {
            disabled: 'rgba(189,1,0,0.48)',
            enabled: '#bd0100',
            focus: '#bd0100',
            hover: '#990000',
            pressed: '#660000',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          shadow: {
            enabled: 'rgba(189,1,0,0.40)',
            hover: 'rgba(189,1,0,0.48)',
            pressed: 'rgba(189,1,0,0.56)',
          },
        },
        secondary: {
          background: {
            disabled: 'rgba(189,1,0,0)',
            enabled: 'rgba(189,1,0,0)',
            focus: 'rgba(189,1,0,0)',
            hover: 'rgba(189,1,0,0.08)',
            pressed: 'rgba(189,1,0,0.16)',
          },
          border: {
            disabled: 'rgba(128,128,128,0.48)',
            enabled: '#808080',
            focus: '#808080',
            hover: '#990000',
            pressed: '#660000',
          },
          content: {
            disabled: 'rgba(189,1,0,0.48)',
            enabled: '#bd0100',
            focus: '#bd0100',
            hover: '#990000',
            pressed: '#660000',
          },
        },
        tertiary: {
          background: {
            disabled: 'rgba(230,230,230,0.48)',
            enabled: '#e6e6e6',
            focus: '#e6e6e6',
            hover: 'rgba(189,1,0,0.08)',
            pressed: 'rgba(189,1,0,0.16)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(189,1,0,0.48)',
            enabled: '#bd0100',
            focus: '#bd0100',
            hover: '#990000',
            pressed: '#660000',
          },
        },
      },
      radius: {
        small: {
          discreet: '4px',
          primary: '4px',
          secondary: '4px',
          tertiary: '4px',
        },
        standard: {
          discreet: '4px',
          primary: '4px',
          secondary: '4px',
          tertiary: '4px',
        },
      },
      shadow: {
        blur: '6px',
        spread: '-2px',
        x: '0',
        y: '6px',
      },
      shadowPressed: {
        blur: '4px',
        spread: '-1px',
        x: '0',
        y: '4px',
      },
      spacing: {
        small: {
          discreet: {
            min: {
              height: '20px',
              width: '20px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '32px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '32px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '32px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
        },
        standard: {
          discreet: {
            min: {
              height: '20px',
              width: '20px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
        },
      },
    },
    onColor: {
      color: {
        discreet: {
          background: {
            disabled: 'rgba(5,87,213,0)',
            enabled: 'rgba(5,87,213,0)',
            focus: 'rgba(5,87,213,0)',
            hover: 'rgba(5,87,213,0.40)',
            pressed: 'rgba(5,87,213,0.48)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
        outline: '#ecf4ff',
        primary: {
          background: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#f2f2f2',
            pressed: '#e6e6e6',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(5,87,213,0.48)',
            enabled: '#0557d5',
            focus: '#0557d5',
            hover: '#013d98',
            pressed: '#012865',
          },
          shadow: {
            enabled: 'rgba(77,77,77,0)',
            hover: 'rgba(77,77,77,0)',
            pressed: 'rgba(77,77,77,0)',
          },
        },
        secondary: {
          background: {
            disabled: 'rgba(77,77,77,0)',
            enabled: 'rgba(77,77,77,0)',
            focus: 'rgba(77,77,77,0)',
            hover: 'rgba(77,77,77,0.08)',
            pressed: 'rgba(77,77,77,0.16)',
          },
          border: {
            disabled: 'rgba(128,128,128,0.48)',
            enabled: '#e6e6e6',
            focus: '#e6e6e6',
            hover: '#d9d9d9',
            pressed: '#cccccc',
          },
          content: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          outline: '#001433',
        },
        tertiary: {
          background: {
            disabled: 'rgba(23,27,38,0.24)',
            enabled: 'rgba(23,27,38,0.40)',
            focus: 'rgba(23,27,38,0.40)',
            hover: 'rgba(5,87,213,0.40)',
            pressed: 'rgba(5,87,213,0.56)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
      },
      radius: {
        small: {
          discreet: '4px',
          primary: '4px',
          secondary: '4px',
          tertiary: '4px',
        },
        standard: {
          discreet: '4px',
          primary: '4px',
          secondary: '4px',
          tertiary: '4px',
        },
      },
      shadow: {
        blur: '6px',
        spread: '-2px',
        x: '0',
        y: '6px',
      },
      shadowPressed: {
        blur: '4px',
        spread: '-1px',
        x: '0',
        y: '4px',
      },
      spacing: {
        small: {
          discreet: {
            min: {
              height: '20px',
              width: '20px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '32px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '32px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '32px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
        },
        standard: {
          discreet: {
            min: {
              height: '20px',
              width: '20px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
        },
      },
    },
    onColorInverse: {
      color: {
        discreet: {
          background: {
            disabled: 'rgba(236,244,255,0)',
            enabled: 'rgba(236,244,255,0)',
            focus: 'rgba(236,244,255,0)',
            hover: 'rgba(236,244,255,0.40)',
            pressed: 'rgba(236,244,255,0.48)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(77,77,77,0.48)',
            enabled: '#333333',
            focus: '#333333',
            hover: '#013d98',
            pressed: '#012865',
          },
        },
        outline: '#001433',
        primary: {
          background: {
            disabled: 'rgba(77,77,77,0.48)',
            enabled: '#4d4d4d',
            focus: '#4d4d4d',
            hover: '#333333',
            pressed: '#1a1a1a',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(204,224,255,0.48)',
            enabled: '#b3d1fe',
            focus: '#b3d1fe',
            hover: '#cce0ff',
            pressed: '#ecf4ff',
          },
          shadow: {
            enabled: 'rgba(77,77,77,0)',
            hover: 'rgba(77,77,77,0)',
            pressed: 'rgba(77,77,77,0)',
          },
        },
        secondary: {
          background: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(236,244,255,0.40)',
            pressed: 'rgba(236,244,255,0.48)',
          },
          border: {
            disabled: 'rgba(77,77,77,0.48)',
            enabled: '#4d4d4d',
            focus: '#4d4d4d',
            hover: '#013d98',
            pressed: '#012865',
          },
          content: {
            disabled: 'rgba(77,77,77,0.48)',
            enabled: '#333333',
            focus: '#333333',
            hover: '#1a1a1a',
            pressed: '#0d0d0d',
          },
          outline: '#001433',
        },
        tertiary: {
          background: {
            disabled: 'rgba(255,255,255,0.16)',
            enabled: 'rgba(255,255,255,0.56)',
            focus: 'rgba(246,247,251,0.48)',
            hover: 'rgba(236,244,255,0.72)',
            pressed: 'rgba(236,244,255,0.80)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(5,87,213,0.48)',
            enabled: '#0557d5',
            focus: '#0557d5',
            hover: '#013d98',
            pressed: '#012865',
          },
        },
      },
      radius: {
        small: {
          discreet: '4px',
          primary: '4px',
          secondary: '4px',
          tertiary: '4px',
        },
        standard: {
          discreet: '4px',
          primary: '4px',
          secondary: '4px',
          tertiary: '4px',
        },
      },
      shadow: {
        blur: '6px',
        spread: '-2px',
        x: '0',
        y: '6px',
      },
      shadowPressed: {
        blur: '4px',
        spread: '-1px',
        x: '0',
        y: '4px',
      },
      spacing: {
        small: {
          discreet: {
            min: {
              height: '20px',
              width: '20px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '32px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '32px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '32px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
        },
        standard: {
          discreet: {
            min: {
              height: '20px',
              width: '20px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
        },
      },
    },
    success: {
      color: {
        discreet: {
          background: {
            disabled: 'rgba(2,120,21,0)',
            enabled: 'rgba(2,120,21,0)',
            focus: 'rgba(2,120,21,0)',
            hover: 'rgba(2,120,21,0.04)',
            pressed: 'rgba(2,120,21,0.08)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(2,120,21,0.48)',
            enabled: '#027815',
            focus: '#027815',
            hover: '#005e0f',
            pressed: '#00450b',
          },
        },
        outline: '#001433',
        primary: {
          background: {
            disabled: 'rgba(2,120,21,0.48)',
            enabled: '#027815',
            focus: '#027815',
            hover: '#005e0f',
            pressed: '#00450b',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          shadow: {
            enabled: 'rgba(2,120,21,0.40)',
            hover: 'rgba(2,120,21,0.48)',
            pressed: 'rgba(2,120,21,0.56)',
          },
        },
        secondary: {
          background: {
            disabled: 'rgba(2,120,21,0)',
            enabled: 'rgba(2,120,21,0)',
            focus: 'rgba(2,120,21,0)',
            hover: 'rgba(2,120,21,0.04)',
            pressed: 'rgba(2,120,21,0.08)',
          },
          border: {
            disabled: 'rgba(128,128,128,0.48)',
            enabled: '#808080',
            focus: '#808080',
            hover: '#005e0f',
            pressed: '#00450b',
          },
          content: {
            disabled: 'rgba(2,120,21,0.48)',
            enabled: '#027815',
            focus: '#027815',
            hover: '#005e0f',
            pressed: '#00450b',
          },
        },
        tertiary: {
          background: {
            disabled: 'rgba(230,230,230,0.48)',
            enabled: '#e6e6e6',
            focus: '#e6e6e6',
            hover: 'rgba(2,120,21,0.04)',
            pressed: 'rgba(2,120,21,0.08)',
          },
          border: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          content: {
            disabled: 'rgba(2,120,21,0.48)',
            enabled: '#027815',
            focus: '#027815',
            hover: '#005e0f',
            pressed: '#00450b',
          },
        },
      },
      radius: {
        small: {
          discreet: '4px',
          primary: '4px',
          secondary: '4px',
          tertiary: '4px',
        },
        standard: {
          discreet: '4px',
          primary: '4px',
          secondary: '4px',
          tertiary: '4px',
        },
      },
      shadow: {
        blur: '6px',
        spread: '-2px',
        x: '0',
        y: '6px',
      },
      shadowPressed: {
        blur: '4px',
        spread: '-1px',
        x: '0',
        y: '4px',
      },
      spacing: {
        small: {
          discreet: {
            min: {
              height: '20px',
              width: '20px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '32px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '32px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '32px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '4px',
              left: '8px',
              right: '8px',
              top: '4px',
            },
          },
        },
        standard: {
          discreet: {
            min: {
              height: '20px',
              width: '20px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '4px',
              right: '4px',
              top: '4px',
            },
          },
          primary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          secondary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
          tertiary: {
            min: {
              height: '40px',
              width: '64px',
            },
            padding: {
              bottom: '4px',
              gap: '8px',
              left: '12px',
              right: '12px',
              top: '4px',
            },
          },
        },
      },
    },
  },
  card: {
    default: {
      color: {
        border: {
          disabled: 'rgba(230,230,230,0.48)',
          enabled: '#e6e6e6',
          focus: '#001433',
          hover: '#d9d9d9',
          pressed: '#cccccc',
        },
        container: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          hover: '#f2f2f2',
          pressed: '#e6e6e6',
        },
        contentBackground: '#e6e6e6',
        danger: '#bd0100',
        dataViz: {
          solid: '#250056',
          transparent: 'rgba(37,0,86,0.32)',
        },
        decorative1: '#250056',
        decorative2: '#ff9300',
        decorative3: '#df216d',
        decorative4: '#0768fd',
        decorative5: '#9e54b0',
        icon: '#cc0077',
        label: {
          disabled: 'rgba(77,77,77,0.48)',
          enabled: '#333333',
          hover: '#1a1a1a',
          pressed: '#0d0d0d',
        },
        neutral: '#4d4d4d',
        sublabel: {
          disabled: 'rgba(77,77,77,0.48)',
          enabled: '#4d4d4d',
          hover: '#333333',
          pressed: '#1a1a1a',
        },
        success: '#027815',
        warning: '#926b00',
      },
      radius: '4px',
      spacing: {
        body: {
          content: {
            padding: {
              bottom: '16px',
              gap: '0',
              left: '16px',
              right: '16px',
              top: '0',
            },
          },
          padding: {
            bottom: '0',
            gap: '0',
            left: '0',
            right: '0',
            top: '0',
          },
        },
        footer: {
          actions: {
            bottom: '0',
            gap: '8px',
            left: '0',
            right: '0',
            top: '0',
          },
          padding: {
            bottom: '16px',
            gap: '16px',
            left: '16px',
            right: '16px',
            top: '16px',
          },
        },
        header: {
          content: {
            padding: {
              bottom: '16px',
              gap: '16px',
              left: '16px',
              right: '16px',
              top: '16px',
            },
          },
          leading: {
            padding: {
              bottom: '0',
              gap: '8px',
              left: '0',
              right: '0',
              top: '0',
            },
          },
          padding: {
            bottom: '0',
            gap: '0',
            left: '0',
            right: '0',
            top: '0',
          },
          trailing: {
            padding: {
              bottom: '16px',
              gap: '8px',
              left: '0',
              right: '16px',
              top: '16px',
            },
          },
        },
        padding: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
  },
  chatBubble: {
    default: {
      color: {
        reply: {
          background: '#ffffff',
          senderLabel: '#ffffff',
          text: '#333333',
        },
        user: {
          background: '#ffe5f4',
          senderLabel: '#ffffff',
          text: '#333333',
        },
      },
      radius: {
        reply: {
          bottomLeft: '2px',
          bottomRight: '24px',
          topLeft: '24px',
          topRight: '24px',
        },
        user: {
          bottomLeft: '24px',
          bottomRight: '2px',
          topLeft: '24px',
          topRight: '24px',
        },
      },
      spacing: {
        footer: {
          actions: {
            gap: '4px',
          },
          gap: '8px',
          top: '4px',
        },
        reply: {
          bottom: '16px',
          left: '16px',
          right: '16px',
          top: '16px',
        },
        replyWithContent: {
          avatar: {
            bottom: '12px',
            left: '16px',
            right: '16px',
            top: '24px',
          },
          default: {
            bottom: '8px',
            left: '16px',
            right: '16px',
            top: '16px',
          },
          suggestion: {
            actions: {
              bottom: '0',
              gap: '8px',
              left: '16px',
              right: '16px',
              top: '0',
            },
            container: {
              bottom: '24px',
              gap: '16px',
              left: '0',
              right: '0',
              top: '12px',
            },
            header: {
              bottom: '0',
              left: '16px',
              right: '16px',
              top: '0',
            },
          },
        },
        user: {
          bottom: '16px',
          left: '16px',
          right: '16px',
          top: '16px',
        },
      },
    },
  },
  chatInputField: {
    default: {
      color: {
        scrollbar: 'rgba(77,77,77,0.16)',
        sendButton: {
          disabled: 'rgba(5,87,213,0.48)',
          enabled: '#0557d5',
        },
      },
      radius: {
        actions: {
          bottomLeft: '24px',
          bottomRIght: '24px',
          topLeft: '0',
          topRight: '0',
        },
        focus: '24px',
        input: {
          bottomLeft: '0',
          bottomRight: '0',
          topLeft: '24px',
          topRight: '24px',
        },
      },
      spacing: {
        actions: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '8px',
          top: '8px',
        },
        input: {
          bottom: '12px',
          left: '16px',
          right: '16px',
          top: '12px',
        },
      },
    },
  },
  chatbot: {
    default: {
      body: {
        sizing: {
          max: {
            width: '1200px',
          },
        },
        spacing: {
          leftSlot: {
            bottom: '8px',
            gap: '0',
            left: '24px',
            progressIndicator: {
              padding: '0',
            },
            right: '72px',
            top: '8px',
          },
          rightSlot: {
            bottom: '8px',
            gap: '0',
            left: '72px',
            right: '24px',
            top: '8px',
          },
        },
      },
      container: {
        radius: {
          bottomLeft: '24px',
          bottomRight: '2px',
          topLeft: '24px',
          topRight: '24px',
        },
        shadow: {
          blur: '24px',
          color: 'rgba(0,0,0,0.16)',
          spread: '2px',
          x: '0',
          y: '8px',
        },
        sizing: {
          minHeight: '600px',
          minWidth: '600px',
        },
      },
      fab: {
        color: {
          border: 'rgba(255,255,255,0.48)',
          state: {
            disabled: 'rgba(13,13,13,0)',
            enabled: 'rgba(13,13,13,0)',
            focus: 'rgba(13,13,13,0)',
            hover: 'rgba(13,13,13,0.16)',
            pressed: 'rgba(13,13,13,0.32)',
          },
        },
        radius: {
          bottomLeft: '24px',
          bottomRight: '2px',
          topLeft: '24px',
          topRight: '24px',
        },
        spacing: {
          left: '8px',
        },
      },
      footer: {
        color: {
          background: 'rgba(153,0,89,0.72)',
          disclaimer: {
            text: {
              enabled: '#ffffff',
            },
            textLink: {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              focus: '#ffffff',
              focusOutline: '#ecf4ff',
              hover: '#ffffff',
              pressed: '#ffffff',
            },
          },
        },
        sizing: {
          max: {
            width: '1200px',
          },
        },
        spacing: {
          bottom: '8px',
          gap: '8px',
          left: '24px',
          right: '24px',
          top: '16px',
        },
      },
      gradient: {
        end: '#cc0077',
        start: '#250056',
      },
      header: {
        color: {
          background: 'rgba(37,0,86,0.72)',
          border: 'rgba(255,255,255,0.48)',
          title: '#ffffff',
        },
        spacing: {
          bottom: '16px',
          gap: '8px',
          left: '16px',
          right: '16px',
          rightIcons: {
            gap: '8px',
          },
          top: '16px',
        },
      },
    },
  },
  checkbox: {
    default: {
      border: {
        control: '1px',
      },
      color: {
        control: {
          background: {
            selected: {
              disabled: 'rgba(5,87,213,0.48)',
              enabled: '#0557d5',
              focus: '#0557d5',
              hover: '#013d98',
              pressed: '#012865',
            },
            unselected: {
              disabled: 'rgba(5,87,213,0)',
              enabled: 'rgba(5,87,213,0)',
              focus: 'rgba(5,87,213,0)',
              hover: 'rgba(5,87,213,0.08)',
              pressed: 'rgba(5,87,213,0.16)',
            },
          },
          border: {
            disabled: 'rgba(128,128,128,0.48)',
            enabled: '#808080',
            focus: '#808080',
            hover: '#013d98',
            pressed: '#012865',
          },
          icon: {
            disabled: '#ffffff',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
        help: {
          enabled: '#4d4d4d',
        },
        label: {
          disabled: 'rgba(77,77,77,0.48)',
          enabled: '#333333',
          focus: '#333333',
          hover: '#1a1a1a',
          pressed: '#0d0d0d',
        },
        outline: '#001433',
      },
      radius: {
        control: '2px',
        focus: '4px',
      },
      sizing: {
        control: {
          container: {
            height: '20px',
            width: '20px',
          },
          small: {
            height: '21px',
          },
          standard: {
            height: '24px',
          },
        },
      },
      spacing: {
        group: {
          horizontal: {
            gap: '12px',
            padding: '4px',
            wrap: '0',
          },
          vertical: {
            gap: '12px',
            padding: '8px',
          },
        },
        small: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
        standard: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
    error: {
      border: {
        control: '2px',
      },
      color: {
        control: {
          background: {
            selected: {
              disabled: 'rgba(189,1,0,0.48)',
              enabled: '#bd0100',
              focus: '#bd0100',
              hover: '#990000',
              pressed: '#660000',
            },
            unselected: {
              disabled: 'rgba(189,1,0,0)',
              enabled: 'rgba(189,1,0,0)',
              focus: 'rgba(189,1,0,0)',
              hover: 'rgba(189,1,0,0.08)',
              pressed: 'rgba(189,1,0,0.16)',
            },
          },
          border: {
            disabled: 'rgba(128,128,128,0.48)',
            enabled: '#bd0100',
            focus: '#bd0100',
            hover: '#990000',
            pressed: '#660000',
          },
          icon: {
            disabled: '#ffffff',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
        help: {
          enabled: '#bd0100',
        },
        label: {
          disabled: 'rgba(77,77,77,0.48)',
          enabled: '#333333',
          focus: '#333333',
          hover: '#1a1a1a',
          pressed: '#0d0d0d',
        },
        outline: '#001433',
      },
      radius: {
        control: '2px',
        focus: '4px',
      },
      sizing: {
        control: {
          container: {
            height: '20px',
            width: '20px',
          },
          small: {
            height: '21px',
          },
          standard: {
            height: '24px',
          },
        },
      },
      spacing: {
        group: {
          horizontal: {
            gap: '12px',
            padding: '4px',
            wrap: '0',
          },
          vertical: {
            gap: '12px',
            padding: '8px',
          },
        },
        small: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
        standard: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
  },
  chip: {
    default: {
      color: {
        background: {
          selected: {
            disabled: 'rgba(5,87,213,0.48)',
            enabled: '#0557d5',
            focus: '#0557d5',
            hover: '#013d98',
            pressed: '#012865',
          },
          unselected: {
            disabled: 'rgba(5,87,213,0)',
            enabled: 'rgba(5,87,213,0)',
            focus: 'rgba(5,87,213,0)',
            hover: 'rgba(5,87,213,0.08)',
            pressed: 'rgba(5,87,213,0.16)',
          },
        },
        border: {
          selected: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0)',
            pressed: 'rgba(255,255,255,0)',
          },
          unselected: {
            disabled: 'rgba(128,128,128,0.48)',
            enabled: '#808080',
            focus: '#808080',
            hover: '#013d98',
            pressed: '#012865',
          },
        },
        icon: {
          selected: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          unselected: {
            disabled: 'rgba(77,77,77,0.48)',
            enabled: '#333333',
            focus: '#333333',
            hover: '#013d98',
            pressed: '#012865',
          },
        },
        label: {
          selected: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          unselected: {
            disabled: 'rgba(77,77,77,0.48)',
            enabled: '#333333',
            focus: '#333333',
            hover: '#013d98',
            pressed: '#012865',
          },
        },
        outline: '#001433',
      },
      radius: {
        small: '9999px',
        standard: '9999px',
      },
      sizing: {
        small: {
          height: '24px',
          icon: '24px',
        },
        standard: {
          height: '32px',
          icon: '24px',
        },
      },
      spacing: {
        group: {
          gap: '8px',
        },
        small: {
          bottom: '2px',
          gap: '0',
          icon: {
            left: '4px',
          },
          label: {
            left: '4px',
            right: '4px',
          },
          left: '2px',
          right: '2px',
          top: '2px',
        },
        standard: {
          bottom: '4px',
          gap: '0',
          icon: {
            left: '4px',
          },
          label: {
            left: '8px',
            right: '8px',
          },
          left: '4px',
          right: '4px',
          top: '4px',
        },
      },
    },
  },
  columnSettingsMenu: {
    default: {
      color: {
        background: {
          default: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#f2f2f2',
            pressed: '#ecf4ff',
          },
          frozen: {
            disabled: 'rgba(246,247,251,0.48)',
            enabled: '#f6f7fb',
            focus: '#f6f7fb',
            hover: '#eaecf6',
            pressed: '#dfe3f1',
          },
        },
        border: {
          frozenUnchecked: {
            disabled: 'rgba(128,128,128,0.48)',
            enabled: '#808080',
            focus: '#808080',
            hover: '#666666',
            pressed: '#4d4d4d',
          },
        },
        focusOutline: '#001433',
        icon: {
          disabled: 'rgba(153,153,153,0.48)',
          enabled: '#999999',
          focus: '#999999',
          hover: '#777777',
          pressed: '#555555',
        },
        label: {
          default: {
            disabled: 'rgba(77,77,77,0.48)',
            enabled: '#333333',
            focus: '#333333',
            hover: '#1a1a1a',
            pressed: '#0d0d0d',
          },
          frozen: {
            disabled: 'rgba(77,77,77,0.48)',
            enabled: '#4d4d4d',
            focus: '#4d4d4d',
            hover: '#333333',
            pressed: '#1a1a1a',
          },
        },
        outline: '#001433',
      },
      height: {
        leadingIcon: '21px',
      },
      padding: {
        freezeLine: {
          right: '16px',
        },
        menuItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '24px',
          top: '8px',
        },
      },
      radius: {
        cell: '0',
        column: '4px',
        focusOutline: '4px',
      },
      strokeWidth: {
        focusOutline: '2px',
      },
    },
  },
  control: {
    default: {
      color: {
        focus: '#000000',
      },
    },
    error: {
      color: {
        focus: '#000000',
      },
    },
  },
  datePicker: {
    default: {
      color: {
        calendar: {
          border: '#e6e6e6',
          container: '#ffffff',
        },
        dayOption: {
          badgeEnabled: '#0557d5',
          badgeHover: '#013d98',
          badgeSelected: '#ffffff',
          fillEnabled: '#ffffff',
          fillEnabledHover: '#ffffff',
          fillSelected: '#0557d5',
          fillSelectedHover: '#013d98',
          todayEnabled: '#4d4d4d',
          todayHover: '#333333',
          todaySelected: '#ffffff',
        },
        option: {
          badgeEnabled: '#0557d5',
          badgeHover: '#013d98',
          badgeSelected: '#b3d1fe',
          fillEnabled: '#ffffff',
          fillEnabledHover: '#cce0ff',
          fillSelected: '#0557d5',
          fillSelectedHover: '#013d98',
          todayEnabled: '#4d4d4d',
          todayHover: '#333333',
          todaySelected: '#b3d1fe',
        },
        typography: {
          disabled: 'rgba(77,77,77,0.48)',
          enabled: '#333333',
          hover: '#1a1a1a',
          selected: '#ffffff',
          static: '#4d4d4d',
        },
      },
      minWidth: '104px',
      radius: {
        option: '9999px',
      },
      sizing: {
        containerMinWidth: '320px',
        dayMaxHeight: '40px',
        dayMaxWidth: '40px',
        dialogMaxHeight: '392px',
        dialogMinWidth: '320px',
        optionMaxHeight: '32px',
        optionMinWidth: '64px',
        small: {
          minWidth: '97px',
        },
        standard: {
          minWidth: '114px',
        },
      },
      spacing: {
        calendarGap: '8px',
        dialogPadding: '16px',
        optionRowGap: '16px',
        small: {
          textGap: '4px',
        },
        standard: {
          textGap: '8px',
        },
      },
    },
  },
  divider: {
    default: {
      color: {
        dark: '#4d4d4d',
        light: '#e6e6e6',
        medium: '#808080',
        semiOpaque: 'rgba(255,255,255,0.48)',
      },
    },
  },
  dragAndDrop: {
    default: {
      background: 'rgba(230,230,230,0.40)',
    },
  },
  fab: {
    default: {
      radius: {
        bottomLeft: '9999px',
        bottomRight: '9999px',
        topLeft: '9999px',
        topRight: '9999px',
      },
      shadow: {
        blur: '24px',
        color: 'rgba(0,0,0,0.16)',
        spread: '2px',
        x: '0',
        y: '8px',
      },
      sizing: {
        label: {
          min: {
            width: '64px',
          },
        },
        noLabel: {
          height: '40px',
          width: '40px',
        },
      },
    },
  },
  fileUploader: {
    default: {
      color: {
        dropZone: {
          background: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#cce0ff',
            pressed: '#b3d1fe',
          },
          border: {
            disabled: 'rgba(77,77,77,0.48)',
            enabled: '#4d4d4d',
            focus: '#4d4d4d',
            hover: '#013d98',
            pressed: '#012865',
          },
          content: {
            disabled: 'rgba(5,87,213,0.48)',
            enabled: '#0557d5',
            focus: '#0557d5',
            hover: '#013d98',
            pressed: '#012865',
          },
        },
        fileListItem: {
          iconError: {
            enabled: '#bd0100',
          },
          iconSuccess: {
            enabled: '#027815',
          },
          text: {
            enabled: '#333333',
          },
        },
        help: {
          enabled: '#4d4d4d',
        },
      },
      spacing: {
        dropZone: {
          gap: '0',
          padding: '8px',
        },
        fileList: {
          padding: {
            right: '0',
          },
        },
        fileListItem: {
          padding: {
            bottom: '8px',
            gapIcon: '8px',
            gapText: '2px',
            left: '4px',
            min: '160px',
            right: '4px',
            top: '8px',
          },
        },
        minWidth: '240px',
        radius: '4px',
      },
    },
    error: {
      color: {
        dropZone: {
          background: {
            disabled: '#fcebeb',
            enabled: '#fcebeb',
            focus: '#fcebeb',
            hover: '#fcebeb',
            pressed: '#fcebeb',
          },
          border: {
            disabled: '#990000',
            enabled: '#990000',
            focus: '#990000',
            hover: '#990000',
            pressed: '#990000',
          },
          content: {
            disabled: '#990000',
            enabled: '#990000',
            focus: '#990000',
            hover: '#990000',
            pressed: '#990000',
          },
        },
        fileListItem: {
          iconError: {
            enabled: '#bd0100',
          },
          iconSuccess: {
            enabled: '#027815',
          },
          text: {
            enabled: '#333333',
          },
        },
        help: {
          enabled: '#4d4d4d',
        },
      },
      spacing: {
        dropZone: {
          gap: '0',
          padding: '8px',
        },
        fileList: {
          padding: {
            right: '0',
          },
        },
        fileListItem: {
          padding: {
            bottom: '8px',
            gapIcon: '8px',
            gapText: '2px',
            left: '4px',
            min: '160px',
            right: '4px',
            top: '8px',
          },
        },
        minWidth: '240px',
        radius: '4px',
      },
    },
  },
  floatingActionColumn: {
    default: {
      border: {
        color: '#cccccc',
        stroke: '1px',
      },
      padding: {
        gap: '0',
        horizontal: '0',
        vertical: '0',
      },
      radius: {
        radius: '0',
      },
      shadow: {
        blur: '20px',
        color: 'rgba(0,0,0,0.08)',
        spread: '0',
        x: '-8px',
        y: '0',
      },
    },
  },
  footer: {
    default: {
      color: {
        content: '#333333',
      },
      sizing: {
        widthMin: '320px',
      },
      spacing: {
        bottomPadding: '24px',
        itemGap: '32px',
        rowGap: '24px',
        sidePadding: '40px',
        topPadding: '40px',
      },
    },
    defaultInverse: {
      color: {
        content: '#ffffff',
      },
      sizing: {
        widthMin: '320px',
      },
      spacing: {
        bottomPadding: '24px',
        itemGap: '32px',
        rowGap: '24px',
        sidePadding: '40px',
        topPadding: '40px',
      },
    },
  },
  functional: {
    borderWidth: {
      focus: {
        default: '2px',
      },
    },
    color: {
      border: {
        accent: {
          disabled: 'rgba(204,0,119,0.48)',
          enabled: '#cc0077',
          hover: '#990059',
          pressed: '#66003c',
        },
        brand: {
          disabled: 'rgba(5,87,213,0.48)',
          enabled: '#0557d5',
          hover: '#013d98',
          pressed: '#012865',
        },
        danger: {
          disabled: 'rgba(189,1,0,0.48)',
          enabled: '#bd0100',
          hover: '#990000',
          pressed: '#660000',
        },
        default: {
          disabled: 'rgba(128,128,128,0.48)',
          enabled: '#808080',
          hover: '#666666',
          pressed: '#4d4d4d',
        },
        'default-inverse': {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        defaultInverse: {
          disabled: 'rgba(77,77,77,0.48)',
          enabled: '#4d4d4d',
          hover: '#333333',
          pressed: '#1a1a1a',
        },
        focus: '#001433',
        'focus-inverse': '#ffffff',
        focusInverse: '#ecf4ff',
        subtle: {
          disabled: 'rgba(230,230,230,0.48)',
          enabled: '#e6e6e6',
          hover: '#d9d9d9',
          pressed: '#cccccc',
        },
        success: {
          disabled: 'rgba(2,120,21,0.48)',
          enabled: '#027815',
          hover: '#005e0f',
          pressed: '#00450b',
        },
        transparent: 'rgba(255,255,255,0)',
        warning: {
          disabled: 'rgba(120,88,0,0.48)',
          enabled: '#926b00',
          hover: '#785800',
          pressed: '#614700',
        },
        white: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
      },
      content: {
        accent: {
          disabled: 'rgba(204,0,119,0.48)',
          enabled: '#cc0077',
          hover: '#990059',
          pressed: '#66003c',
        },
        'accent-inverse': {
          disabled: 'rgba(230,230,230,0.48)',
          enabled: 'rgba(230,230,230,1)',
          hover: 'rgba(230,230,230,1)',
          pressed: 'rgba(230,230,230,1)',
        },
        accentInverse: {
          disabled: 'rgba(255,229,244,0.48)',
          enabled: '#ffb2df',
          hover: '#ffccea',
          pressed: '#ffe5f4',
        },
        brand: {
          disabled: 'rgba(5,87,213,0.48)',
          enabled: '#0557d5',
          hover: '#013d98',
          pressed: '#012865',
        },
        'brand-inverse': {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        brandInverse: {
          disabled: 'rgba(204,224,255,0.48)',
          enabled: '#b3d1fe',
          hover: '#cce0ff',
          pressed: '#ecf4ff',
        },
        danger: {
          disabled: 'rgba(189,1,0,0.48)',
          enabled: '#bd0100',
          hover: '#990000',
          pressed: '#660000',
        },
        'danger-inverse': {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        dangerInverse: {
          disabled: 'rgba(252,235,235,0.48)',
          enabled: '#ffb2b2',
          hover: '#ffcccc',
          pressed: '#fcebeb',
        },
        default: {
          disabled: 'rgba(77,77,77,0.48)',
          enabled: '#333333',
          hover: '#1a1a1a',
          pressed: '#0d0d0d',
        },
        'default-inverse': {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        defaultInverse: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        subtle: {
          disabled: 'rgba(77,77,77,0.48)',
          enabled: '#4d4d4d',
          hover: '#333333',
          pressed: '#1a1a1a',
        },
        'subtle-inverse': {
          disabled: '#ffffff',
          enabled: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        subtleInverse: {
          disabled: 'rgba(230,230,230,0.48)',
          enabled: '#e6e6e6',
          hover: '#f2f2f2',
          pressed: '#ffffff',
        },
        success: {
          disabled: 'rgba(2,120,21,0.48)',
          enabled: '#027815',
          hover: '#005e0f',
          pressed: '#00450b',
        },
        'success-inverse': {
          disabled: 'rgba(255,255,255,0)',
          enabled: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        successInverse: {
          disabled: 'rgba(229,255,234,0.48)',
          enabled: '#b2ffbf',
          hover: '#ccffd4',
          pressed: '#e5ffea',
        },
        warning: {
          disabled: 'rgba(240,179,35,0.48)',
          enabled: '#f4c65a',
          hover: '#f7d991',
          pressed: '#fbecc8',
        },
        'warning-inverse': {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        warningInverse: {
          disabled: 'rgba(120,88,0,0.48)',
          enabled: '#926b00',
          hover: '#785800',
          pressed: '#614700',
        },
      },
      dataViz: {
        content: {
          axis: '#808080',
          label: '#4d4d4d',
          title: {
            enabled: '#333333',
            hover: '#2e2e2e',
            pressed: '#292929',
          },
        },
        five: {
          enabled: '#005587',
          hover: '#005587',
          pressed: '#005587',
        },
        four: {
          enabled: '#028217',
          hover: '#028217',
          pressed: '#028217',
        },
        gray: {
          enabled: '#bfbfbf',
          hover: '#bfbfbf',
          pressed: '#bfbfbf',
        },
        one: {
          enabled: '#9e54b0',
          hover: '#9e54b0',
          pressed: '#9e54b0',
        },
        six: {
          enabled: '#d18100',
          hover: '#d18100',
          pressed: '#d18100',
        },
        three: {
          enabled: '#df216d',
          hover: '#df216d',
          pressed: '#df216d',
        },
        two: {
          enabled: '#076bfd',
          hover: '#076bfd',
          pressed: '#076bfd',
        },
      },
      decorative: {
        five: {
          contrast: '#5e3069',
          enabled: '#9e54b0',
          hover: 'rgba(158,84,176,0.08)',
          inverse: '#f5eef7',
          pressed: 'rgba(158,84,176,0.32)',
        },
        four: {
          contrast: '#013d98',
          enabled: '#0768fd',
          hover: 'rgba(7,104,253,0.08)',
          inverse: '#e6f0ff',
          pressed: 'rgba(7,104,253,0.32)',
        },
        one: {
          contrast: '#0f0024',
          enabled: '#250056',
          hover: 'rgba(37,0,86,0.08)',
          inverse: '#f0e5ff',
          pressed: 'rgba(37,0,86,0.32)',
        },
        three: {
          contrast: '#861341',
          enabled: '#df216d',
          hover: 'rgba(223,33,109,0.08)',
          inverse: '#fce9f0',
          pressed: 'rgba(223,33,109,0.32)',
        },
        two: {
          contrast: '#995900',
          enabled: '#ff9300',
          hover: 'rgba(255,147,0,0.08)',
          inverse: '#fff4e5',
          pressed: 'rgba(255,147,0,0.32)',
        },
      },
      surface: {
        background: {
          disabled: 'rgba(246,247,251,0.48)',
          enabled: '#f6f7fb',
          hover: '#eaecf6',
          pressed: '#dfe3f1',
        },
        'background-inverse': {
          disabled: 'rgba(0,0,0,0.48)',
          enabled: '#000000',
          hover: '#000000',
          pressed: '#000000',
        },
        backgroundInverse: {
          disabled: 'rgba(23,27,38,0.40)',
          enabled: '#0c0f18',
          hover: '#171b26',
          pressed: '#292c32',
        },
        container: {
          gradient: {
            accent: {
              end: '#990059',
              start: '#66003c',
            },
            brand: {
              end: '#013d98',
              start: '#012865',
            },
            neutral: {
              end: '#eaecf6',
              start: '#dfe3f1',
            },
            neutralInverse: {
              end: '#333333',
              start: '#1a1a1a',
            },
          },
          opaque: {
            accent: {
              disabled: 'rgba(204,0,119,0.40)',
              enabled: 'rgba(204,0,119,0.72)',
              hover: 'rgba(204,0,119,0.80)',
              pressed: 'rgba(204,0,119,0.88)',
            },
            'accent-inverse': {
              disabled: 'rgba(230,230,230,0)',
              enabled: 'rgba(230,230,230,0)',
              hover: 'rgba(230,230,230,0)',
              pressed: 'rgba(230,230,230,0)',
            },
            accentInverse: {
              disabled: 'rgba(255,229,244,0.40)',
              enabled: 'rgba(255,229,244,0.72)',
              hover: 'rgba(255,229,244,0.80)',
              pressed: 'rgba(255,229,244,0.88)',
            },
            background: {
              disabled: 'rgba(246,247,251,0.40)',
              enabled: 'rgba(246,247,251,0.72)',
              hover: 'rgba(246,247,251,0.80)',
              pressed: 'rgba(246,247,251,0.88)',
            },
            'background-inverse': {
              disabled: 'rgba(0,0,0,0.48)',
              enabled: '#000000',
              hover: '#000000',
              pressed: '#000000',
            },
            backgroundInverse: {
              disabled: 'rgba(23,27,38,0.40)',
              enabled: 'rgba(23,27,38,0.72)',
              hover: 'rgba(23,27,38,0.80)',
              pressed: 'rgba(23,27,38,0.88)',
            },
            brand: {
              disabled: 'rgba(5,87,213,0.40)',
              enabled: 'rgba(5,87,213,0.72)',
              hover: 'rgba(5,87,213,0.80)',
              pressed: 'rgba(5,87,213,0.88)',
            },
            'brand-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            brandInverse: {
              disabled: 'rgba(236,244,255,0.40)',
              enabled: 'rgba(236,244,255,0.72)',
              hover: 'rgba(236,244,255,0.80)',
              pressed: 'rgba(236,244,255,0.88)',
            },
            danger: {
              disabled: 'rgba(189,1,0,0.40)',
              enabled: 'rgba(189,1,0,0.72)',
              hover: 'rgba(189,1,0,0.80)',
              pressed: 'rgba(189,1,0,0.88)',
            },
            'danger-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            dangerInverse: {
              disabled: 'rgba(252,235,235,0.40)',
              enabled: 'rgba(252,235,235,0.72)',
              hover: 'rgba(252,235,235,0.80)',
              pressed: 'rgba(252,235,235,0.88)',
            },
            default: {
              disabled: 'rgba(255,255,255,0.40)',
              enabled: 'rgba(255,255,255,0.72)',
              hover: 'rgba(255,255,255,0.80)',
              pressed: 'rgba(255,255,255,0.88)',
            },
            'default-inverse': {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
            defaultInverse: {
              disabled: 'rgba(77,77,77,0.40)',
              enabled: 'rgba(77,77,77,0.72)',
              hover: 'rgba(77,77,77,0.80)',
              pressed: 'rgba(77,77,77,0.88)',
            },
            subtle: {
              disabled: 'rgba(230,230,230,0.40)',
              enabled: 'rgba(230,230,230,0.72)',
              hover: 'rgba(230,230,230,0.80)',
              pressed: 'rgba(230,230,230,0.88)',
            },
            'subtle-inverse': {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
            subtleInverse: {
              disabled: 'rgba(128,128,128,0.40)',
              enabled: 'rgba(128,128,128,0.72)',
              hover: 'rgba(128,128,128,0.80)',
              pressed: 'rgba(128,128,128,0.88)',
            },
            success: {
              disabled: 'rgba(2,120,21,0.40)',
              enabled: 'rgba(2,120,21,0.72)',
              hover: 'rgba(2,120,21,0.80)',
              pressed: 'rgba(2,120,21,0.88)',
            },
            'success-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            successInverse: {
              disabled: 'rgba(229,255,234,0.40)',
              enabled: 'rgba(229,255,234,0.72)',
              hover: 'rgba(229,255,234,0.80)',
              pressed: 'rgba(229,255,234,0.88)',
            },
            warning: {
              disabled: 'rgba(240,179,35,0.40)',
              enabled: 'rgba(240,179,35,0.72)',
              hover: 'rgba(240,179,35,0.80)',
              pressed: 'rgba(240,179,35,0.88)',
            },
            'warning-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            warningInverse: {
              disabled: 'rgba(244,198,90,0.40)',
              enabled: 'rgba(244,198,90,0.72)',
              hover: 'rgba(244,198,90,0.80)',
              pressed: 'rgba(244,198,90,0.88)',
            },
          },
          solid: {
            accent: {
              disabled: 'rgba(204,0,119,0.48)',
              enabled: '#cc0077',
              hover: '#990059',
              pressed: '#66003c',
            },
            'accent-inverse': {
              disabled: 'rgba(230,230,230,0.48)',
              enabled: 'rgba(230,230,230,1)',
              hover: 'rgba(230,230,230,1)',
              pressed: 'rgba(230,230,230,1)',
            },
            accentInverse: {
              disabled: 'rgba(255,229,244,0.48)',
              enabled: '#ffe5f4',
              hover: '#ffccea',
              pressed: '#ffb2df',
            },
            brand: {
              disabled: 'rgba(5,87,213,0.48)',
              enabled: '#0557d5',
              hover: '#013d98',
              pressed: '#012865',
            },
            'brand-inverse': {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              hover: '#ffffff',
              pressed: '#ffffff',
            },
            brandInverse: {
              disabled: 'rgba(236,244,255,0.48)',
              enabled: '#ecf4ff',
              hover: '#cce0ff',
              pressed: '#b3d1fe',
            },
            danger: {
              disabled: 'rgba(189,1,0,0.48)',
              enabled: '#bd0100',
              hover: '#990000',
              pressed: '#660000',
            },
            'danger-inverse': {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              hover: '#ffffff',
              pressed: '#ffffff',
            },
            dangerInverse: {
              disabled: 'rgba(252,235,235,0.48)',
              enabled: '#fcebeb',
              hover: '#ffcccc',
              pressed: '#ffb2b2',
            },
            default: {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              hover: '#f2f2f2',
              pressed: '#e6e6e6',
            },
            'default-inverse': {
              disabled: 'rgba(0,0,0,0.48)',
              enabled: '#000000',
              hover: '#000000',
              pressed: '#000000',
            },
            defaultInverse: {
              disabled: 'rgba(77,77,77,0.48)',
              enabled: '#4d4d4d',
              hover: '#333333',
              pressed: '#1a1a1a',
            },
            'focus-outline': '#000000',
            'focus-outline-inverse': '#ffffff',
            focusOutline: '#001433',
            focusOutlineInverse: '#ecf4ff',
            subtle: {
              disabled: 'rgba(230,230,230,0.48)',
              enabled: '#e6e6e6',
              hover: '#d9d9d9',
              pressed: '#cccccc',
            },
            subtleInverse: {
              disabled: 'rgba(128,128,128,0.48)',
              enabled: '#808080',
              hover: '#666666',
              pressed: '#4d4d4d',
            },
            success: {
              disabled: 'rgba(2,120,21,0.48)',
              enabled: '#027815',
              hover: '#005e0f',
              pressed: '#00450b',
            },
            'success-inverse': {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              hover: '#ffffff',
              pressed: '#ffffff',
            },
            successInverse: {
              disabled: 'rgba(229,255,234,0.48)',
              enabled: '#e5ffea',
              hover: '#ccffd4',
              pressed: '#b2ffbf',
            },
            warning: {
              disabled: 'rgba(240,179,35,0.48)',
              enabled: '#f0b323',
              hover: '#f4c65a',
              pressed: '#f7d991',
            },
            'warning-inverse': {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              hover: '#ffffff',
              pressed: '#ffffff',
            },
            warningInverse: {
              disabled: 'rgba(244,198,90,0.48)',
              enabled: '#fbecc8',
              hover: '#f7d991',
              pressed: '#f4c65a',
            },
          },
          translucent: {
            accent: {
              disabled: 'rgba(204,0,119,0.24)',
              enabled: 'rgba(204,0,119,0.40)',
              hover: 'rgba(204,0,119,0.48)',
              pressed: 'rgba(204,0,119,0.56)',
            },
            'accent-inverse': {
              disabled: 'rgba(230,230,230,0)',
              enabled: 'rgba(230,230,230,0)',
              hover: 'rgba(230,230,230,0)',
              pressed: 'rgba(230,230,230,0)',
            },
            accentInverse: {
              disabled: 'rgba(255,229,244,0.24)',
              enabled: 'rgba(255,229,244,0.40)',
              hover: 'rgba(255,229,244,0.48)',
              pressed: 'rgba(255,229,244,0.56)',
            },
            background: {
              disabled: 'rgba(246,247,251,0.24)',
              enabled: 'rgba(246,247,251,0.40)',
              hover: 'rgba(246,247,251,0.48)',
              pressed: 'rgba(246,247,251,0.56)',
            },
            'background-inverse': {
              disabled: 'rgba(0,0,0,0.48)',
              enabled: '#000000',
              hover: '#000000',
              pressed: '#000000',
            },
            backgroundInverse: {
              disabled: 'rgba(23,27,38,0.24)',
              enabled: 'rgba(23,27,38,0.40)',
              hover: 'rgba(23,27,38,0.48)',
              pressed: 'rgba(23,27,38,0.56)',
            },
            brand: {
              disabled: 'rgba(5,87,213,0.24)',
              enabled: 'rgba(5,87,213,0.40)',
              hover: 'rgba(5,87,213,0.48)',
              pressed: 'rgba(5,87,213,0.56)',
            },
            'brand-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            brandInverse: {
              disabled: 'rgba(236,244,255,0.24)',
              enabled: 'rgba(236,244,255,0.40)',
              hover: 'rgba(236,244,255,0.48)',
              pressed: 'rgba(236,244,255,0.56)',
            },
            danger: {
              disabled: 'rgba(189,1,0,0.24)',
              enabled: 'rgba(189,1,0,0.40)',
              hover: 'rgba(189,1,0,0.48)',
              pressed: 'rgba(189,1,0,0.56)',
            },
            'danger-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            dangerInverse: {
              disabled: 'rgba(252,235,235,0.24)',
              enabled: 'rgba(252,235,235,0.40)',
              hover: 'rgba(252,235,235,0.48)',
              pressed: 'rgba(252,235,235,0.56)',
            },
            default: {
              disabled: 'rgba(255,255,255,0.24)',
              enabled: 'rgba(255,255,255,0.40)',
              hover: 'rgba(255,255,255,0.48)',
              pressed: 'rgba(255,255,255,0.56)',
            },
            'default-inverse': {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
            defaultInverse: {
              disabled: 'rgba(77,77,77,0.24)',
              enabled: 'rgba(77,77,77,0.40)',
              hover: 'rgba(77,77,77,0.48)',
              pressed: 'rgba(77,77,77,0.56)',
            },
            subtle: {
              disabled: 'rgba(230,230,230,0.24)',
              enabled: 'rgba(230,230,230,0.40)',
              hover: 'rgba(230,230,230,0.48)',
              pressed: 'rgba(230,230,230,0.56)',
            },
            'subtle-inverse': {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
            subtleInverse: {
              disabled: 'rgba(128,128,128,0.56)',
              enabled: 'rgba(128,128,128,0.40)',
              hover: 'rgba(128,128,128,0.48)',
              pressed: 'rgba(128,128,128,0.56)',
            },
            success: {
              disabled: 'rgba(2,120,21,0.16)',
              enabled: 'rgba(2,120,21,0.40)',
              hover: 'rgba(2,120,21,0.48)',
              pressed: 'rgba(2,120,21,0.56)',
            },
            'success-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            successInverse: {
              disabled: 'rgba(229,255,234,0.16)',
              enabled: 'rgba(229,255,234,0.40)',
              hover: 'rgba(229,255,234,0.48)',
              pressed: 'rgba(229,255,234,0.56)',
            },
            warning: {
              disabled: 'rgba(240,179,35,0.16)',
              enabled: 'rgba(240,179,35,0.40)',
              hover: 'rgba(240,179,35,0.48)',
              pressed: 'rgba(240,179,35,0.56)',
            },
            'warning-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            warningInverse: {
              disabled: 'rgba(244,198,90,0.16)',
              enabled: 'rgba(244,198,90,0.40)',
              hover: 'rgba(244,198,90,0.48)',
              pressed: 'rgba(244,198,90,0.56)',
            },
          },
          transparent: {
            accent: {
              disabled: 'rgba(178,26,87,0)',
              enabled: 'rgba(178,26,87,0)',
              hover: 'rgba(204,0,119,0.08)',
              pressed: 'rgba(204,0,119,0.16)',
            },
            'accent-inverse': {
              disabled: 'rgba(230,230,230,0)',
              enabled: 'rgba(230,230,230,0)',
              hover: 'rgba(230,230,230,0)',
              pressed: 'rgba(230,230,230,0)',
            },
            accentInverse: {
              disabled: 'rgba(255,229,244,0)',
              enabled: 'rgba(255,229,244,0)',
              hover: 'rgba(255,229,244,0.08)',
              pressed: 'rgba(255,229,244,0.16)',
            },
            background: {
              disabled: 'rgba(246,247,251,0)',
              enabled: 'rgba(246,247,251,0)',
              hover: 'rgba(246,247,251,0.08)',
              pressed: 'rgba(246,247,251,0.16)',
            },
            'background-inverse': {
              disabled: 'rgba(0,0,0,0.48)',
              enabled: '#000000',
              hover: '#000000',
              pressed: '#000000',
            },
            backgroundInverse: {
              disabled: 'rgba(23,27,38,0)',
              enabled: 'rgba(23,27,38,0)',
              hover: 'rgba(23,27,38,0.08)',
              pressed: 'rgba(23,27,38,0.16)',
            },
            brand: {
              disabled: 'rgba(5,87,213,0)',
              enabled: 'rgba(5,87,213,0)',
              hover: 'rgba(5,87,213,0.08)',
              pressed: 'rgba(5,87,213,0.16)',
            },
            'brand-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            brandInverse: {
              disabled: 'rgba(236,244,255,0)',
              enabled: 'rgba(236,244,255,0)',
              hover: 'rgba(236,244,255,0.08)',
              pressed: 'rgba(236,244,255,0.16)',
            },
            danger: {
              disabled: 'rgba(189,1,0,0)',
              enabled: 'rgba(189,1,0,0)',
              hover: 'rgba(189,1,0,0.08)',
              pressed: 'rgba(189,1,0,0.16)',
            },
            'danger-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            dangerInverse: {
              disabled: 'rgba(252,235,235,0)',
              enabled: 'rgba(252,235,235,0)',
              hover: 'rgba(252,235,235,0.08)',
              pressed: 'rgba(252,235,235,0.16)',
            },
            default: {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0.08)',
              pressed: 'rgba(255,255,255,0.16)',
            },
            'default-inverse': {
              disabled: 'rgba(0,0,0,0)',
              enabled: 'rgba(0,0,0,0)',
              hover: 'rgba(0,0,0,0)',
              pressed: 'rgba(0,0,0,0)',
            },
            defaultInverse: {
              disabled: 'rgba(77,77,77,0)',
              enabled: 'rgba(77,77,77,0)',
              hover: 'rgba(77,77,77,0.08)',
              pressed: 'rgba(77,77,77,0.16)',
            },
            subtle: {
              disabled: 'rgba(230,230,230,0)',
              enabled: 'rgba(230,230,230,0)',
              hover: 'rgba(230,230,230,0.08)',
              pressed: 'rgba(230,230,230,0.16)',
            },
            subtleInverse: {
              disabled: 'rgba(128,128,128,0.48)',
              enabled: 'rgba(128,128,128,0)',
              hover: 'rgba(128,128,128,0.08)',
              pressed: 'rgba(128,128,128,0.16)',
            },
            success: {
              disabled: 'rgba(2,120,21,0)',
              enabled: 'rgba(2,120,21,0)',
              hover: 'rgba(2,120,21,0.04)',
              pressed: 'rgba(2,120,21,0.08)',
            },
            'success-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            successInverse: {
              disabled: 'rgba(229,255,234,0)',
              enabled: 'rgba(229,255,234,0)',
              hover: 'rgba(229,255,234,0.04)',
              pressed: 'rgba(229,255,234,0.08)',
            },
            warning: {
              disabled: 'rgba(240,179,35,0)',
              enabled: 'rgba(240,179,35,0)',
              hover: 'rgba(240,179,35,0.04)',
              pressed: 'rgba(240,179,35,0.08)',
            },
            'warning-inverse': {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              hover: 'rgba(255,255,255,0)',
              pressed: 'rgba(255,255,255,0)',
            },
            warningInverse: {
              disabled: 'rgba(244,198,90,0)',
              enabled: 'rgba(244,198,90,0)',
              hover: 'rgba(244,198,90,0.04)',
              pressed: 'rgba(244,198,90,0.08)',
            },
          },
        },
      },
    },
    radius: {
      action: {
        '100': '4px',
        '200': '2px',
        '300': '9999px',
      },
      circle: '9999px',
      container: {
        '100': '4px',
        '200': '2px',
        '300': '24px',
      },
      content: {
        '100': '9999px',
        '200': '4px',
        '300': '4px',
        '400': '8px',
        '500': '12px',
      },
      input: {
        '100': '4px',
        '200': '2px',
      },
      navigation: {
        '100': '0',
        '200': '4px',
      },
      none: '0',
      overlay: {
        '100': '4px',
        '200': '2px',
      },
    },
    shadow: {
      levelFour: {
        blur: '24px',
        color: 'rgba(0,0,0,0.16)',
        spread: '2px',
        x: '0',
        y: '8px',
      },
      levelOne: {
        blur: '16px',
        color: 'rgba(0,0,0,0.04)',
        spread: '0',
        x: '0',
        y: '4px',
      },
      levelThree: {
        blur: '20px',
        color: 'rgba(0,0,0,0.08)',
        spread: '0',
        x: '0',
        y: '8px',
      },
      levelTwo: {
        blur: '6px',
        color: 'rgba(5,87,213,0.32)',
        spread: '-2px',
        x: '0',
        y: '6px',
      },
      levelTwoHover: {
        blur: '8px',
        color: 'rgba(1,61,152,0.32)',
        spread: '0',
        x: '0',
        y: '4px',
      },
      levelTwoPressed: {
        blur: '4px',
        color: 'rgba(1,40,101,0.32)',
        spread: '-1px',
        x: '0',
        y: '4px',
      },
      scrollingOverlay: {
        bottom: {
          blur: '16px',
          spread: '0',
          x: '0',
          y: '-8px',
        },
        color: 'rgba(0,0,0,0.08)',
        left: {
          blur: '16px',
          spread: '0',
          x: '8px',
          y: '0',
        },
        right: {
          blur: '16px',
          spread: '0',
          x: '-8px',
          y: '0',
        },
        stroke: '#cccccc',
        top: {
          blur: '16px',
          spread: '0',
          x: '0',
          y: '8px',
        },
      },
    },
    sizing: {
      action: {
        comfortable: '32px',
        compact: '20px',
        cozy: '24px',
        expanded: '40px',
        spacious: '48px',
        vast: '64px',
      },
      breakpoint: {
        compact: '320px',
        large: '1200px',
        medium: '900px',
        small: '600px',
        xl: '1536px',
      },
      container: {
        comfortable: '320px',
        compact: '48px',
        cozy: '64px',
        expanded: '480px',
        spacious: '600px',
      },
      content: {
        comfortable: '16px',
        compact: '8px',
        cozy: '12px',
        expanded: '20px',
        spacious: '24px',
      },
      input: {
        comfortable: '64px',
        compact: '32px',
        cozy: '40px',
        expanded: '160px',
        spacious: '240px',
      },
      lineHeight: {
        bodyDefault: '24px',
        bodySmall: '21px',
        caption: '20px',
        headline: '53px',
        subheadline: '35px',
        subtile: '30px',
        title: '36px',
      },
      navigation: {
        comfortable: '40px',
        compact: '20px',
        cozy: '24px',
        expanded: '56px',
        spacious: '64px',
      },
      none: '0',
      overlay: {
        comfortable: '64px',
        compact: '24px',
        cozy: '48px',
        expanded: '240px',
        spacious: '480px',
      },
    },
    spacing: {
      action: {
        comfortable: '8px',
        compact: '2px',
        cozy: '4px',
        expanded: '16px',
        spacious: '24px',
      },
      container: {
        comfortable: '12px',
        compact: '4px',
        cozy: '8px',
        expanded: '16px',
        spacious: '24px',
      },
      content: {
        comfortable: '8px',
        compact: '2px',
        cozy: '4px',
        expanded: '16px',
        spacious: '24px',
      },
      input: {
        comfortable: '8px',
        compact: '2px',
        cozy: '4px',
        expanded: '12px',
        spacious: '16px',
      },
      navigation: {
        comfortable: '16px',
        compact: '4px',
        cozy: '8px',
        expanded: '24px',
        spacious: '32px',
      },
      none: '0',
      overlay: {
        comfortable: '12px',
        compact: '4px',
        cozy: '8px',
        expanded: '16px',
        spacious: '24px',
      },
    },
  },
  global: {
    motion: {
      default: {
        duration: '200ms',
        easing: 'cubic-bezier(0.38, 0.0, 1, 1)',
        transition: '200ms cubic-bezier(0.38, 0.0, 1, 1)',
      },
      instant: {
        duration: '0ms',
      },
    },
    typography: {
      default: {
        fontFamily: "'Proxima Nova', 'Nunito Sans', 'Noto Sans', 'Helvetica', 'Arial', sans-serif",
      },
    },
  },
  grid: {
    color: {
      solid: {
        default: {
          accent: {
            background: '#ffe5f4',
            border: 'rgba(77,77,77,0.08)',
          },
          brand: {
            background: '#ecf4ff',
            border: 'rgba(77,77,77,0.08)',
          },
          danger: {
            background: '#fcebeb',
            border: 'rgba(77,77,77,0.08)',
          },
          decorative1: {
            background: '#f0e5ff',
            border: 'rgba(77,77,77,0.08)',
          },
          decorative2: {
            background: '#fff4e5',
            border: 'rgba(77,77,77,0.08)',
          },
          decorative3: {
            background: '#fce9f0',
            border: 'rgba(77,77,77,0.08)',
          },
          decorative4: {
            background: '#e6f0ff',
            border: 'rgba(77,77,77,0.08)',
          },
          decorative5: {
            background: '#f5eef7',
            border: 'rgba(77,77,77,0.08)',
          },
          neutral: {
            background: '#ffffff',
            border: 'rgba(77,77,77,0.08)',
          },
          success: {
            background: '#e5ffea',
            border: 'rgba(77,77,77,0.08)',
          },
          warning: {
            background: '#fbecc8',
            border: 'rgba(77,77,77,0.08)',
          },
        },
        inverse: {
          accent: {
            background: '#66003c',
            border: 'rgba(255,255,255,0.08)',
          },
          brand: {
            background: '#012865',
            border: 'rgba(255,255,255,0.08)',
          },
          danger: {
            background: '#660000',
            border: 'rgba(255,255,255,0.08)',
          },
          decorative1: {
            background: '#0f0024',
            border: 'rgba(255,255,255,0.08)',
          },
          decorative2: {
            background: '#995900',
            border: 'rgba(255,255,255,0.08)',
          },
          decorative3: {
            background: '#861341',
            border: 'rgba(255,255,255,0.08)',
          },
          decorative4: {
            background: '#013d98',
            border: 'rgba(255,255,255,0.08)',
          },
          decorative5: {
            background: '#5e3069',
            border: 'rgba(255,255,255,0.08)',
          },
          neutral: {
            background: '#1a1a1a',
            border: 'rgba(255,255,255,0.08)',
          },
          success: {
            background: '#00450b',
            border: 'rgba(255,255,255,0.08)',
          },
          warning: {
            background: '#614700',
            border: 'rgba(255,255,255,0.08)',
          },
        },
      },
      translucent: {
        default: {
          accent: {
            background: 'rgba(255,229,244,0.56)',
            border: 'rgba(77,77,77,0.08)',
          },
          brand: {
            background: 'rgba(236,244,255,0.56)',
            border: 'rgba(77,77,77,0.08)',
          },
          danger: {
            background: 'rgba(252,235,235,0.56)',
            border: 'rgba(77,77,77,0.08)',
          },
          decorative1: {
            background: 'rgba(240,229,255,0.56)',
            border: 'rgba(77,77,77,0.08)',
          },
          decorative2: {
            background: 'rgba(255,244,229,0.56)',
            border: 'rgba(77,77,77,0.08)',
          },
          decorative3: {
            background: 'rgba(252,233,240,0.56)',
            border: 'rgba(77,77,77,0.08)',
          },
          decorative4: {
            background: 'rgba(230,240,255,0.56)',
            border: 'rgba(77,77,77,0.08)',
          },
          decorative5: {
            background: 'rgba(245,238,247,0.56)',
            border: 'rgba(77,77,77,0.08)',
          },
          neutral: {
            background: 'rgba(255,255,255,0.56)',
            border: 'rgba(77,77,77,0.08)',
          },
          success: {
            background: 'rgba(229,255,234,0.56)',
            border: 'rgba(77,77,77,0.08)',
          },
          warning: {
            background: 'rgba(244,198,90,0.48)',
            border: 'rgba(77,77,77,0.08)',
          },
        },
        inverse: {
          accent: {
            background: 'rgba(204,0,119,0.40)',
            border: 'rgba(255,255,255,0.08)',
          },
          brand: {
            background: 'rgba(5,87,213,0.16)',
            border: 'rgba(255,255,255,0.08)',
          },
          danger: {
            background: 'rgba(189,1,0,0.16)',
            border: 'rgba(255,255,255,0.08)',
          },
          decorative1: {
            background: 'rgba(37,0,86,0.32)',
            border: 'rgba(255,255,255,0.08)',
          },
          decorative2: {
            background: 'rgba(255,147,0,0.32)',
            border: 'rgba(255,255,255,0.08)',
          },
          decorative3: {
            background: 'rgba(223,33,109,0.32)',
            border: 'rgba(255,255,255,0.08)',
          },
          decorative4: {
            background: 'rgba(7,104,253,0.32)',
            border: 'rgba(255,255,255,0.08)',
          },
          decorative5: {
            background: 'rgba(158,84,176,0.32)',
            border: 'rgba(255,255,255,0.08)',
          },
          neutral: {
            background: 'rgba(23,27,38,0.40)',
            border: 'rgba(255,255,255,0.08)',
          },
          success: {
            background: 'rgba(2,120,21,0.08)',
            border: 'rgba(255,255,255,0.08)',
          },
          warning: {
            background: 'rgba(120,88,0,0.48)',
            border: 'rgba(255,255,255,0.08)',
          },
        },
      },
      transparent: {
        default: {
          accent: {
            background: 'rgba(255,229,244,0.08)',
            border: 'rgba(77,77,77,0.08)',
          },
          brand: {
            background: 'rgba(236,244,255,0.08)',
            border: 'rgba(77,77,77,0.08)',
          },
          danger: {
            background: 'rgba(252,235,235,0.08)',
            border: 'rgba(77,77,77,0.08)',
          },
          decorative1: {
            background: 'rgba(240,229,255,0.08)',
            border: 'rgba(77,77,77,0.08)',
          },
          decorative2: {
            background: 'rgba(255,244,229,0.08)',
            border: 'rgba(77,77,77,0.08)',
          },
          decorative3: {
            background: 'rgba(252,233,240,0.08)',
            border: 'rgba(77,77,77,0.08)',
          },
          decorative4: {
            background: 'rgba(230,240,255,0.08)',
            border: 'rgba(77,77,77,0.08)',
          },
          decorative5: {
            background: 'rgba(245,238,247,0.08)',
            border: 'rgba(77,77,77,0.08)',
          },
          neutral: {
            background: 'rgba(255,255,255,0.08)',
            border: 'rgba(77,77,77,0.08)',
          },
          success: {
            background: 'rgba(229,255,234,0.04)',
            border: 'rgba(77,77,77,0.08)',
          },
          warning: {
            background: 'rgba(244,198,90,0.08)',
            border: 'rgba(77,77,77,0.08)',
          },
        },
        inverse: {
          accent: {
            background: 'rgba(204,0,119,0.08)',
            border: 'rgba(255,255,255,0.08)',
          },
          brand: {
            background: 'rgba(5,87,213,0.08)',
            border: 'rgba(255,255,255,0.08)',
          },
          danger: {
            background: 'rgba(189,1,0,0.08)',
            border: 'rgba(255,255,255,0.08)',
          },
          decorative1: {
            background: 'rgba(37,0,86,0.08)',
            border: 'rgba(255,255,255,0.08)',
          },
          decorative2: {
            background: 'rgba(255,147,0,0.08)',
            border: 'rgba(255,255,255,0.08)',
          },
          decorative3: {
            background: 'rgba(223,33,109,0.08)',
            border: 'rgba(255,255,255,0.08)',
          },
          decorative4: {
            background: 'rgba(7,104,253,0.08)',
            border: 'rgba(255,255,255,0.08)',
          },
          decorative5: {
            background: 'rgba(158,84,176,0.08)',
            border: 'rgba(255,255,255,0.08)',
          },
          neutral: {
            background: 'rgba(77,77,77,0.08)',
            border: 'rgba(255,255,255,0.08)',
          },
          success: {
            background: 'rgba(2,120,21,0.04)',
            border: 'rgba(255,255,255,0.08)',
          },
          warning: {
            background: 'rgba(240,179,35,0.08)',
            border: 'rgba(255,255,255,0.08)',
          },
        },
      },
    },
    effects: {
      default: {
        blur: {
          background: '48px',
        },
      },
    },
    layout: {
      default: {
        count: '12px',
        gutter: '16px',
        margin: '0',
      },
    },
    radius: {
      default: {
        default: '8px',
      },
      round: {
        default: '16px',
      },
      sharp: {
        default: '4px',
      },
    },
    sizing: {
      default: {
        border: '1px',
      },
    },
    spacing: {
      compact: {
        padding: '8px',
      },
      default: {
        padding: '16px',
      },
      spacious: {
        padding: '24px',
      },
    },
  },
  gridlines: {
    default: {
      color: {
        content: {
          enabled: '#4d4d4d',
        },
        grids: {
          enabled: '#808080',
        },
      },
      padding: {
        bottom: '8px',
        gap: '8px',
        left: '8px',
        right: '8px',
        top: '4px',
      },
    },
  },
  hero: {
    accent: {
      color: {
        content: {
          enabled: '#ffffff',
        },
        surface: {
          enabled: '#cc0077',
          gradient: {
            stop1: '#66003c',
            stop2: '#990059',
          },
        },
      },
      sizing: {
        min: {
          container: {
            width: '320px',
          },
          headline: {
            width: '272px',
          },
        },
      },
      spacing: {
        actionButton: {
          gap: '16px',
        },
        container: {
          bottom: '24px',
          gap: '24px',
          left: '24px',
          right: '24px',
          top: '24px',
        },
      },
    },
    brand: {
      color: {
        content: {
          enabled: '#ffffff',
        },
        surface: {
          enabled: '#0557d5',
          gradient: {
            stop1: '#012865',
            stop2: '#013d98',
          },
        },
      },
      sizing: {
        min: {
          container: {
            width: '320px',
          },
          headline: {
            width: '272px',
          },
        },
      },
      spacing: {
        actionButton: {
          gap: '16px',
        },
        container: {
          bottom: '24px',
          gap: '24px',
          left: '24px',
          right: '24px',
          top: '24px',
        },
      },
    },
    classic: {
      color: {
        content: {
          enabled: '#ffffff',
        },
        surface: {
          enabled: '#250056',
        },
      },
      sizing: {
        min: {
          container: {
            width: '320px',
          },
        },
      },
      spacing: {
        actionButton: {
          gap: '16px',
        },
        container: {
          bottom: '24px',
          gap: '16px',
          left: '24px',
          right: '24px',
          top: '24px',
        },
      },
    },
    inverse: {
      color: {
        content: {
          enabled: '#ffffff',
        },
        surface: {
          enabled: '#000000',
          gradient: {
            stop1: '#1a1a1a',
            stop2: '#333333',
          },
        },
      },
      sizing: {
        min: {
          container: {
            width: '320px',
          },
          headline: {
            width: '272px',
          },
        },
      },
      spacing: {
        actionButton: {
          gap: '16px',
        },
        container: {
          bottom: '24px',
          gap: '24px',
          left: '24px',
          right: '24px',
          top: '24px',
        },
      },
    },
    neutral: {
      color: {
        content: {
          enabled: '#333333',
        },
        surface: {
          enabled: '#f6f7fb',
          gradient: {
            stop1: '#dfe3f1',
            stop2: '#eaecf6',
          },
        },
      },
      sizing: {
        min: {
          container: {
            width: '320px',
          },
          headline: {
            width: '272px',
          },
        },
      },
      spacing: {
        actionButton: {
          gap: '16px',
        },
        container: {
          bottom: '24px',
          gap: '24px',
          left: '24px',
          right: '24px',
          top: '24px',
        },
      },
    },
  },
  icon: {
    IDS: {
      color: {
        internalDesignBackground: '#4d4d4d',
      },
      sizing: {
        lg: {
          height: '32px',
          width: '32px',
        },
        lineHeight: {
          bodyDefault: '24px',
          bodySmall: '21px',
          caption: '20px',
          headline: '53px',
          subheadline: '35px',
          subtitle: '30px',
          title: '36px',
        },
        md: {
          height: '24px',
          width: '24px',
        },
        sm: {
          height: '20px',
          width: '20px',
        },
        xs: {
          height: '16px',
          width: '16px',
        },
      },
    },
    SLDS: {
      color: {
        internalDesignBackground: '#4d4d4d',
      },
      sizing: {
        lg: {
          height: '26px',
          width: '26px',
        },
        lineHeight: {
          bodyDefault: '24px',
          bodySmall: '21px',
          caption: '20px',
          headline: '53px',
          subheadline: '35px',
          subtitle: '30px',
          title: '36px',
        },
        md: {
          height: '24px',
          width: '24px',
        },
        sm: {
          height: '14px',
          width: '14px',
        },
        xs: {
          height: '10px',
          width: '10px',
        },
      },
    },
  },
  iconButton: {
    default: {
      color: {
        background: {
          disabled: 'rgba(5,87,213,0)',
          enabled: 'rgba(5,87,213,0)',
          filled: '#ffffff',
          focus: 'rgba(5,87,213,0.08)',
          hover: 'rgba(5,87,213,0.08)',
          pressed: 'rgba(5,87,213,0.16)',
          selected: '#0557d5',
        },
        border: {
          disabled: 'rgba(128,128,128,0.48)',
          enabled: '#808080',
          focus: '#808080',
          hover: '#013d98',
          pressed: '#012865',
        },
        icon: {
          disabled: 'rgba(77,77,77,0.48)',
          enabled: '#4d4d4d',
          focus: '#013d98',
          hover: '#013d98',
          pressed: '#012865',
          selected: '#ffffff',
        },
        outline: '#001433',
      },
      padding: {
        extraSmall: '2px',
        small: '4px',
        standard: '8px',
      },
      radius: '9999px',
      sizing: {
        extraSmall: {
          height: '24px',
          width: '24px',
        },
        small: {
          height: '32px',
          width: '32px',
        },
        standard: {
          height: '48px',
          width: '48px',
        },
      },
    },
    error: {
      color: {
        background: {
          disabled: 'rgba(189,1,0,0)',
          enabled: 'rgba(189,1,0,0)',
          filled: '#ffffff',
          focus: 'rgba(189,1,0,0.08)',
          hover: 'rgba(189,1,0,0.08)',
          pressed: 'rgba(189,1,0,0.16)',
          selected: '#bd0100',
        },
        border: {
          disabled: 'rgba(128,128,128,0.48)',
          enabled: '#808080',
          focus: '#808080',
          hover: '#990000',
          pressed: '#660000',
        },
        icon: {
          disabled: 'rgba(77,77,77,0.48)',
          enabled: '#4d4d4d',
          focus: '#990000',
          hover: '#990000',
          pressed: '#660000',
          selected: '#ffffff',
        },
        outline: '#001433',
      },
      padding: {
        extraSmall: '2px',
        small: '4px',
        standard: '8px',
      },
      radius: '9999px',
      sizing: {
        extraSmall: {
          height: '24px',
          width: '24px',
        },
        small: {
          height: '32px',
          width: '32px',
        },
        standard: {
          height: '48px',
          width: '48px',
        },
      },
    },
    onColor: {
      color: {
        background: {
          disabled: 'rgba(255,255,255,0)',
          enabled: 'rgba(255,255,255,0)',
          filled: '#4d4d4d',
          focus: 'rgba(255,255,255,0.08)',
          hover: 'rgba(255,255,255,0.08)',
          pressed: 'rgba(255,255,255,0.16)',
        },
        border: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          focus: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        icon: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          focus: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        outline: '#ffffff',
      },
      padding: {
        extraSmall: '2px',
        small: '4px',
        standard: '8px',
      },
      radius: '9999px',
      sizing: {
        extraSmall: {
          height: '24px',
          width: '24px',
        },
        small: {
          height: '32px',
          width: '32px',
        },
        standard: {
          height: '48px',
          width: '48px',
        },
      },
    },
    onColorInverse: {
      color: {
        background: {
          disabled: 'rgba(77,77,77,0)',
          enabled: 'rgba(77,77,77,0)',
          filled: '#4d4d4d',
          focus: 'rgba(77,77,77,0.08)',
          hover: 'rgba(77,77,77,0.08)',
          pressed: 'rgba(77,77,77,0.16)',
        },
        border: {
          disabled: 'rgba(77,77,77,0.48)',
          enabled: '#4d4d4d',
          focus: '#4d4d4d',
          hover: '#333333',
          pressed: '#1a1a1a',
        },
        icon: {
          disabled: 'rgba(77,77,77,0.48)',
          enabled: '#333333',
          focus: '#1a1a1a',
          hover: '#1a1a1a',
          pressed: '#0d0d0d',
        },
        outline: '#333333',
      },
      padding: {
        extraSmall: '2px',
        small: '4px',
        standard: '8px',
      },
      radius: '9999px',
      sizing: {
        extraSmall: {
          height: '24px',
          width: '24px',
        },
        small: {
          height: '32px',
          width: '32px',
        },
        standard: {
          height: '48px',
          width: '48px',
        },
      },
    },
    toggle: {
      color: {
        background: {
          disabled: 'rgba(5,87,213,0)',
          enabled: 'rgba(5,87,213,0)',
          filled: '#ffffff',
          focus: 'rgba(5,87,213,0.08)',
          hover: 'rgba(5,87,213,0.08)',
          pressed: 'rgba(5,87,213,0.16)',
          selected: '#000000',
        },
        border: {
          disabled: '#666666',
          enabled: '#e6e6e6',
          focus: '#808080',
          hover: '#666666',
          pressed: '#4d4d4d',
        },
        icon: {
          disabled: 'rgba(77,77,77,0.48)',
          enabled: '#4d4d4d',
          focus: '#333333',
          hover: '#333333',
          pressed: '#1a1a1a',
          selected: '#ffffff',
        },
        outline: '#001433',
      },
      padding: {
        extraSmall: '2px',
        small: '4px',
        standard: '8px',
      },
      radius: '9999px',
      sizing: {
        extraSmall: {
          height: '24px',
          width: '24px',
        },
        small: {
          height: '32px',
          width: '32px',
        },
        standard: {
          height: '48px',
          width: '48px',
        },
      },
    },
  },
  label: {
    default: {
      color: {
        asterisk: '#bd0100',
        optional: '#4d4d4d',
        text: '#333333',
      },
      spacing: {
        padding: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
  },
  list: {
    default: {
      color: {
        background: {
          inset: '#e6e6e6',
        },
        border: '#e6e6e6',
        scrollbar: 'rgba(77,77,77,0.16)',
      },
      radius: '4px',
      spacing: {
        padding: {
          compact: {
            basic: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            inset: {
              bottom: '8px',
              gap: '8px',
              left: '8px',
              right: '8px',
              top: '8px',
            },
            modal: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
          },
          default: {
            basic: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            inset: {
              bottom: '16px',
              gap: '16px',
              left: '16px',
              right: '16px',
              top: '16px',
            },
            modal: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
          },
        },
      },
    },
  },
  listItem: {
    default: {
      color: {
        background: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          focus: '#e6e6e6',
          hover: '#f2f2f2',
          pressed: '#d9d9d9',
        },
        border: {
          disabled: 'rgba(230,230,230,0.48)',
          enabled: '#e6e6e6',
          focus: '#cccccc',
          hover: '#d9d9d9',
          pressed: '#cccccc',
        },
        icon: {
          disabled: 'rgba(77,77,77,0.48)',
          enabled: '#333333',
          focus: '#333333',
          hover: '#013d98',
          pressed: '#012865',
        },
        leadingIcon: {
          disabled: 'rgba(77,77,77,0.48)',
          enabled: '#333333',
          focus: '#012865',
          hover: '#013d98',
          pressed: '#012865',
        },
        text: {
          label: {
            disabled: 'rgba(77,77,77,0.48)',
            enabled: '#333333',
            focus: '#012865',
            hover: '#013d98',
            pressed: '#012865',
          },
          sub: {
            disabled: 'rgba(77,77,77,0.48)',
            enabled: '#4d4d4d',
            focus: '#012865',
            hover: '#013d98',
            pressed: '#012865',
          },
        },
        trailingIcon: {
          disabled: 'rgba(128,128,128,0.48)',
          enabled: '#808080',
          focus: '#012865',
          hover: '#013d98',
          pressed: '#012865',
        },
      },
      radius: {
        small: '0',
        standard: '0',
      },
      sizing: {
        icon: {
          small: {
            height: '12px',
            width: '12px',
          },
          standard: {
            height: '16px',
            width: '16px',
          },
        },
      },
      spacing: {
        small: {
          min: {
            height: '30px',
            width: '64px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            leading: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            left: '8px',
            right: '16px',
            text: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            top: '4px',
            trailing: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
          },
        },
        standard: {
          min: {
            height: '40px',
            width: '64px',
          },
          padding: {
            bottom: '8px',
            gap: '8px',
            leading: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            left: '8px',
            right: '16px',
            text: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            top: '8px',
            trailing: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
          },
        },
      },
    },
    error: {
      color: {
        background: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          focus: '#e6e6e6',
          hover: '#f2f2f2',
          pressed: '#d9d9d9',
        },
        border: {
          disabled: 'rgba(230,230,230,0.48)',
          enabled: '#e6e6e6',
          focus: '#cccccc',
          hover: '#d9d9d9',
          pressed: '#cccccc',
        },
        icon: {
          disabled: 'rgba(189,1,0,0.48)',
          enabled: '#bd0100',
          focus: '#bd0100',
          hover: '#990000',
          pressed: '#660000',
        },
        leadingIcon: {
          disabled: 'rgba(189,1,0,0.48)',
          enabled: '#bd0100',
          focus: '#660000',
          hover: '#990000',
          pressed: '#660000',
        },
        text: {
          label: {
            disabled: 'rgba(189,1,0,0.48)',
            enabled: '#bd0100',
            focus: '#660000',
            hover: '#990000',
            pressed: '#660000',
          },
          sub: {
            disabled: 'rgba(189,1,0,0.48)',
            enabled: '#bd0100',
            focus: '#660000',
            hover: '#990000',
            pressed: '#660000',
          },
        },
        trailingIcon: {
          disabled: 'rgba(189,1,0,0.48)',
          enabled: '#bd0100',
          focus: '#660000',
          hover: '#990000',
          pressed: '#660000',
        },
      },
      radius: {
        small: '0',
        standard: '0',
      },
      sizing: {
        icon: {
          small: {
            height: '12px',
            width: '12px',
          },
          standard: {
            height: '16px',
            width: '16px',
          },
        },
      },
      spacing: {
        small: {
          min: {
            height: '30px',
            width: '64px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            leading: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            left: '8px',
            right: '16px',
            text: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            top: '4px',
            trailing: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
          },
        },
        standard: {
          min: {
            height: '40px',
            width: '64px',
          },
          padding: {
            bottom: '8px',
            gap: '8px',
            leading: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            left: '8px',
            right: '16px',
            text: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            top: '8px',
            trailing: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
          },
        },
      },
    },
  },
  menu: {
    default: {
      color: {
        background: {
          list: '#ffffff',
        },
      },
      spacing: {
        padding: {
          bottom: '0',
          gap: '8px',
          left: '0',
          list: {
            bottom: '8px',
            gap: '0',
            left: '0',
            right: '0',
            top: '8px',
          },
          right: '0',
          top: '0',
        },
      },
    },
  },
  modal: {
    default: {
      color: {
        body: {
          text: '#333333',
        },
        border: '#e6e6e6',
        colorBar: '#0557d5',
        container: '#ffffff',
        header: {
          heading: '#333333',
          subheading: '#4d4d4d',
        },
        scrim: 'rgba(77,77,77,0.48)',
      },
      radius: {
        container: '4px',
      },
      sizing: {
        width: {
          max: '600px',
          min: '320px',
        },
      },
      spacing: {
        body: {
          bottom: '16px',
          gap: '0',
          left: '24px',
          right: '24px',
          top: '16px',
        },
        container: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
        footer: {
          bottom: '16px',
          gap: '8px',
          left: '24px',
          right: '24px',
          top: '8px',
        },
        header: {
          bottom: '0',
          content: {
            bottom: '8px',
            gap: '16px',
            left: '24px',
            right: '24px',
            text: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            top: '24px',
          },
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
    error: {
      color: {
        body: {
          text: '#333333',
        },
        border: '#e6e6e6',
        colorBar: '#bd0100',
        container: '#ffffff',
        header: {
          heading: '#333333',
          subheading: '#4d4d4d',
        },
        scrim: 'rgba(77,77,77,0.48)',
      },
      radius: {
        container: '4px',
      },
      sizing: {
        width: {
          max: '600px',
          min: '320px',
        },
      },
      spacing: {
        body: {
          bottom: '16px',
          gap: '0',
          left: '24px',
          right: '24px',
          top: '16px',
        },
        container: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '4px',
        },
        footer: {
          bottom: '16px',
          gap: '8px',
          left: '24px',
          right: '24px',
          top: '8px',
        },
        header: {
          bottom: '0',
          content: {
            bottom: '8px',
            gap: '16px',
            left: '24px',
            right: '24px',
            text: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            top: '24px',
          },
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
    success: {
      color: {
        body: {
          text: '#333333',
        },
        border: '#e6e6e6',
        colorBar: '#027815',
        container: '#ffffff',
        header: {
          heading: '#333333',
          subheading: '#4d4d4d',
        },
        scrim: 'rgba(77,77,77,0.48)',
      },
      radius: {
        container: '4px',
      },
      sizing: {
        width: {
          max: '600px',
          min: '320px',
        },
      },
      spacing: {
        body: {
          bottom: '16px',
          gap: '0',
          left: '24px',
          right: '24px',
          top: '16px',
        },
        container: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '4px',
        },
        footer: {
          bottom: '16px',
          gap: '8px',
          left: '24px',
          right: '24px',
          top: '8px',
        },
        header: {
          bottom: '0',
          content: {
            bottom: '8px',
            gap: '16px',
            left: '24px',
            right: '24px',
            text: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            top: '24px',
          },
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
    warning: {
      color: {
        body: {
          text: '#333333',
        },
        border: '#e6e6e6',
        colorBar: '#f4c65a',
        container: '#ffffff',
        header: {
          heading: '#333333',
          subheading: '#4d4d4d',
        },
        scrim: 'rgba(77,77,77,0.48)',
      },
      radius: {
        container: '4px',
      },
      sizing: {
        width: {
          max: '600px',
          min: '320px',
        },
      },
      spacing: {
        body: {
          bottom: '16px',
          gap: '0',
          left: '24px',
          right: '24px',
          top: '16px',
        },
        container: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '4px',
        },
        footer: {
          bottom: '16px',
          gap: '8px',
          left: '24px',
          right: '24px',
          top: '8px',
        },
        header: {
          bottom: '0',
          content: {
            bottom: '8px',
            gap: '16px',
            left: '24px',
            right: '24px',
            text: {
              bottom: '0',
              gap: '0',
              left: '0',
              right: '0',
              top: '0',
            },
            top: '24px',
          },
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
  },
  navItem: {
    inverse: {
      color: {
        background: {
          control: {
            disabled: 'rgba(23,27,38,0.24)',
            enabled: 'rgba(23,27,38,0.40)',
            focus: 'rgba(23,27,38,0.40)',
            hover: 'rgba(5,87,213,0.40)',
            pressed: 'rgba(5,87,213,0.56)',
          },
          default: {
            disabled: 'rgba(23,27,38,0)',
            enabled: 'rgba(23,27,38,0)',
            focus: 'rgba(23,27,38,0)',
            hover: 'rgba(23,27,38,0.16)',
            pressed: 'rgba(23,27,38,0.40)',
          },
          insetGroup: 'rgba(230,230,230,0.08)',
          selected: {
            enabled: 'rgba(255,255,255,0.08)',
            focus: 'rgba(255,255,255,0.08)',
            hover: 'rgba(255,255,255,0.16)',
            pressed: 'rgba(255,255,255,0.16)',
          },
        },
        border: {
          default: 'rgba(128,128,128,0.16)',
          focus: '#ecf4ff',
          selected: 'rgba(23,27,38,0.40)',
        },
        content: {
          control: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ecf4ff',
            pressed: '#cce0ff',
          },
          default: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#cce0ff',
            pressed: '#b3d1fe',
          },
          selected: {
            enabled: '#ecf4ff',
            focus: '#ecf4ff',
            hover: '#cce0ff',
            pressed: '#b3d1fe',
          },
        },
      },
      radius: {
        control: '9999px',
        insetGroup: '8px',
      },
    },
    neutral: {
      color: {
        background: {
          control: {
            disabled: 'rgba(255,255,255,0.40)',
            enabled: 'rgba(255,255,255,0.72)',
            focus: 'rgba(255,255,255,0.72)',
            hover: 'rgba(236,244,255,0.72)',
            pressed: 'rgba(236,244,255,0.88)',
          },
          default: {
            disabled: 'rgba(246,247,251,0)',
            enabled: 'rgba(246,247,251,0)',
            focus: 'rgba(246,247,251,0)',
            hover: 'rgba(246,247,251,0.16)',
            pressed: 'rgba(246,247,251,0.40)',
          },
          insetGroup: 'rgba(128,128,128,0.08)',
          selected: {
            enabled: 'rgba(128,128,128,0.08)',
            focus: 'rgba(128,128,128,0.08)',
            hover: 'rgba(128,128,128,0.16)',
            pressed: 'rgba(128,128,128,0.16)',
          },
        },
        border: {
          default: 'rgba(128,128,128,0.08)',
          focus: '#001433',
          selected: 'rgba(230,230,230,0.40)',
        },
        content: {
          control: {
            disabled: 'rgba(77,77,77,0.48)',
            enabled: '#333333',
            focus: '#333333',
            hover: '#013d98',
            pressed: '#012865',
          },
          default: {
            disabled: 'rgba(77,77,77,0.48)',
            enabled: '#333333',
            focus: '#333333',
            hover: '#1a1a1a',
            pressed: '#0d0d0d',
          },
          selected: {
            enabled: '#013d98',
            focus: '#013d98',
            hover: '#012865',
            pressed: '#012865',
          },
        },
      },
      radius: {
        control: '9999px',
        insetGroup: '8px',
      },
    },
  },
  navbar: {
    accent: {
      color: {
        border: {
          sidebarItem: 'rgba(255,255,255,0.04)',
        },
        content: {
          item: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
            selected: '#ffffff',
          },
          text: {
            enabled: '#ffffff',
          },
        },
        notificationBell: '#4d4d4d',
        outline: {
          focus: '#ffe5f4',
        },
        surface: {
          background: {
            enabled: '#990059',
            gradient: {
              stop1: '#66003c',
              stop2: '#990059',
            },
            overlay: 'rgba(204,0,119,0.16)',
          },
          item: {
            disabled: 'rgba(178,26,87,0)',
            enabled: 'rgba(178,26,87,0)',
            focus: 'rgba(178,26,87,0)',
            hover: 'rgba(255,255,255,0.08)',
            pressed: 'rgba(255,255,255,0.12)',
            selected: 'rgba(255,255,255,0.18)',
          },
        },
        wave: {
          five: '#0557d5',
          four: '#cc0077',
          one: '#ffffff',
          three: '#df216d',
          two: '#1a1a1a',
        },
      },
      sizing: {
        icon: {
          height: '20px',
          width: '20px',
        },
        item: {
          height: '56px',
        },
        navbar: {
          max: {
            width: '1200px',
          },
          min: {
            width: '320px',
          },
        },
        nestedItem: {
          height: '40px',
        },
        sidebar: {
          collapsed: {
            width: '64px',
          },
          expanded: {
            width: '320px',
          },
        },
      },
      spacing: {
        appName: {
          bottom: '0',
          gap: '16px',
          left: '0',
          right: '0',
          top: '0',
        },
        divider: {
          bottom: '4px',
          gap: '0',
          left: '32px',
          right: '0',
          top: '4px',
        },
        dividerContainer: {
          bottom: '0',
          gap: '0',
          left: '16px',
          right: '0',
          top: '0',
        },
        item: {
          bottom: '16px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '16px',
        },
        menuItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedSidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '28px',
          right: '0',
          top: '0',
        },
        sidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '56px',
        },
        sidebarTabsContainer: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
        titleItem: {
          bottom: '4px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '4px',
        },
        utility: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '8px',
          top: '0',
        },
      },
    },
    brand: {
      color: {
        border: {
          sidebarItem: 'rgba(255,255,255,0.04)',
        },
        content: {
          item: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
            selected: '#ffffff',
          },
          text: {
            enabled: '#ffffff',
          },
        },
        notificationBell: '#4d4d4d',
        outline: {
          focus: '#ecf4ff',
        },
        surface: {
          background: {
            enabled: '#013d98',
            gradient: {
              stop1: '#012865',
              stop2: '#013d98',
            },
            overlay: 'rgba(5,87,213,0.16)',
          },
          item: {
            disabled: 'rgba(5,87,213,0)',
            enabled: 'rgba(5,87,213,0)',
            focus: 'rgba(5,87,213,0)',
            hover: 'rgba(255,255,255,0.08)',
            pressed: 'rgba(255,255,255,0.12)',
            selected: 'rgba(255,255,255,0.18)',
          },
        },
        wave: {
          five: '#cc0077',
          four: '#0557d5',
          one: '#ffffff',
          three: '#9e54b0',
          two: '#0d0d0d',
        },
      },
      sizing: {
        icon: {
          height: '20px',
          width: '20px',
        },
        item: {
          height: '56px',
        },
        navbar: {
          max: {
            width: '1200px',
          },
          min: {
            width: '320px',
          },
        },
        nestedItem: {
          height: '40px',
        },
        sidebar: {
          collapsed: {
            width: '64px',
          },
          expanded: {
            width: '320px',
          },
        },
      },
      spacing: {
        appName: {
          bottom: '0',
          gap: '16px',
          left: '0',
          right: '0',
          top: '0',
        },
        divider: {
          bottom: '4px',
          gap: '0',
          left: '32px',
          right: '0',
          top: '4px',
        },
        dividerContainer: {
          bottom: '0',
          gap: '0',
          left: '16px',
          right: '0',
          top: '0',
        },
        item: {
          bottom: '16px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '16px',
        },
        menuItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedSidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '28px',
          right: '0',
          top: '0',
        },
        sidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '56px',
        },
        sidebarTabsContainer: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
        titleItem: {
          bottom: '4px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '4px',
        },
        utility: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '8px',
          top: '0',
        },
      },
    },
    classic: {
      color: {
        border: {
          sidebarItem: 'rgba(37,0,86,0.12)',
        },
        content: {
          item: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
            selected: '#ffffff',
          },
          text: {
            enabled: '#ffffff',
          },
        },
        notificationBell: '#4d4d4d',
        outline: {
          focus: '#ecf4ff',
        },
        surface: {
          background: {
            enabled: '#250056',
            gradient: {
              stop1: '#250056',
              stop2: '#0076ae',
            },
            overlay: 'rgba(37,0,86,0.08)',
          },
          item: {
            disabled: 'rgba(230,230,230,0)',
            enabled: 'rgba(230,230,230,0)',
            focus: 'rgba(230,230,230,0)',
            hover: 'rgba(255,255,255,0.08)',
            pressed: 'rgba(255,255,255,0.12)',
            selected: 'rgba(255,255,255,0.18)',
          },
        },
        wave: {
          five: '#ffffff',
          four: '#ffffff',
          one: '#ffffff',
          three: '#ffffff',
          two: '#1a1a1a',
        },
      },
      sizing: {
        icon: {
          height: '20px',
          width: '20px',
        },
        item: {
          height: '56px',
        },
        navbar: {
          max: {
            width: '1200px',
          },
          min: {
            width: '320px',
          },
        },
        nestedItem: {
          height: '40px',
        },
        sidebar: {
          collapsed: {
            width: '64px',
          },
          expanded: {
            width: '320px',
          },
        },
      },
      spacing: {
        appName: {
          bottom: '0',
          gap: '16px',
          left: '0',
          right: '0',
          top: '0',
        },
        divider: {
          bottom: '4px',
          gap: '0',
          left: '32px',
          right: '0',
          top: '4px',
        },
        dividerContainer: {
          bottom: '0',
          gap: '0',
          left: '16px',
          right: '0',
          top: '0',
        },
        item: {
          bottom: '16px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '16px',
        },
        menuItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedSidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '29px',
          right: '0',
          top: '0',
        },
        sidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '56px',
        },
        sidebarTabsContainer: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
        titleItem: {
          bottom: '4px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '4px',
        },
        utility: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '8px',
          top: '0',
        },
      },
    },
    inverse: {
      color: {
        border: {
          sidebarItem: 'rgba(255,255,255,0.04)',
        },
        content: {
          item: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#e6e6e6',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
            selected: '#ffffff',
          },
          text: {
            enabled: '#ffffff',
          },
        },
        notificationBell: '#4d4d4d',
        outline: {
          focus: '#ecf4ff',
        },
        surface: {
          background: {
            enabled: '#333333',
            gradient: {
              stop1: '#1a1a1a',
              stop2: '#333333',
            },
            overlay: 'rgba(77,77,77,0.16)',
          },
          item: {
            disabled: 'rgba(230,230,230,0)',
            enabled: 'rgba(230,230,230,0)',
            focus: 'rgba(230,230,230,0)',
            hover: 'rgba(230,230,230,0.08)',
            pressed: 'rgba(230,230,230,0.12)',
            selected: 'rgba(230,230,230,0.18)',
          },
        },
        wave: {
          five: '#990059',
          four: '#013d98',
          one: '#0557d5',
          three: 'rgba(158,84,176,0.32)',
          two: '#0d0d0d',
        },
      },
      sizing: {
        icon: {
          height: '20px',
          width: '20px',
        },
        item: {
          height: '56px',
        },
        navbar: {
          max: {
            width: '1200px',
          },
          min: {
            width: '320px',
          },
        },
        nestedItem: {
          height: '40px',
        },
        sidebar: {
          collapsed: {
            width: '64px',
          },
          expanded: {
            width: '320px',
          },
        },
      },
      spacing: {
        appName: {
          bottom: '0',
          gap: '16px',
          left: '0',
          right: '0',
          top: '0',
        },
        divider: {
          bottom: '4px',
          gap: '0',
          left: '32px',
          right: '0',
          top: '4px',
        },
        dividerContainer: {
          bottom: '0',
          gap: '0',
          left: '16px',
          right: '0',
          top: '0',
        },
        item: {
          bottom: '16px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '16px',
        },
        menuItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedSidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '28px',
          right: '0',
          top: '0',
        },
        sidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '56px',
        },
        sidebarTabsContainer: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
        titleItem: {
          bottom: '4px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '4px',
        },
        utility: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '8px',
          top: '0',
        },
      },
    },
    neutral: {
      color: {
        border: {
          sidebarItem: 'rgba(255,255,255,0.04)',
        },
        content: {
          item: {
            disabled: 'rgba(77,77,77,0.48)',
            enabled: '#333333',
            focus: '#333333',
            hover: '#1a1a1a',
            pressed: '#0d0d0d',
            selected: '#0d0d0d',
          },
          text: {
            enabled: '#333333',
          },
        },
        notificationBell: '#4d4d4d',
        outline: {
          focus: '#013d98',
        },
        surface: {
          background: {
            enabled: '#f6f7fb',
            gradient: {
              stop1: '#dfe3f1',
              stop2: '#eaecf6',
            },
            overlay: 'rgba(230,230,230,0.16)',
          },
          item: {
            disabled: 'rgba(77,77,77,0)',
            enabled: 'rgba(77,77,77,0)',
            focus: 'rgba(77,77,77,0)',
            hover: 'rgba(77,77,77,0.08)',
            pressed: 'rgba(77,77,77,0.12)',
            selected: 'rgba(77,77,77,0.18)',
          },
        },
        wave: {
          five: '#ffb2df',
          four: '#b3d1fe',
          one: '#0557d5',
          three: 'rgba(223,33,109,0.32)',
          two: 'rgba(77,77,77,0.16)',
        },
      },
      sizing: {
        icon: {
          height: '20px',
          width: '20px',
        },
        item: {
          height: '56px',
        },
        navbar: {
          max: {
            width: '1200px',
          },
          min: {
            width: '320px',
          },
        },
        nestedItem: {
          height: '40px',
        },
        sidebar: {
          collapsed: {
            width: '64px',
          },
          expanded: {
            width: '320px',
          },
        },
      },
      spacing: {
        appName: {
          bottom: '0',
          gap: '16px',
          left: '0',
          right: '0',
          top: '0',
        },
        divider: {
          bottom: '4px',
          gap: '0',
          left: '32px',
          right: '0',
          top: '4px',
        },
        dividerContainer: {
          bottom: '0',
          gap: '0',
          left: '16px',
          right: '0',
          top: '0',
        },
        item: {
          bottom: '16px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '16px',
        },
        menuItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedItem: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        nestedSidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '28px',
          right: '0',
          top: '0',
        },
        sidebarTabs: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '56px',
        },
        sidebarTabsContainer: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '0',
          top: '0',
        },
        titleItem: {
          bottom: '4px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '4px',
        },
        utility: {
          bottom: '0',
          gap: '0',
          left: '0',
          right: '8px',
          top: '0',
        },
      },
    },
  },
  pagination: {
    default: {
      color: {
        barBackground: {
          enabled: '#f6f7fb',
        },
        barBorder: {
          enabled: '#e6e6e6',
        },
        label: {
          enabled: '#4d4d4d',
        },
        outline: '#001433',
      },
      padding: {
        multiPage: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
        pagination: {
          bottom: '10px',
          gap: '0',
          left: '16px',
          right: '16px',
          top: '10px',
        },
        select: {
          bottom: '0',
          gap: '8px',
          left: '0',
          right: '0',
          top: '0',
        },
        singlePage: {
          bottom: '0',
          gap: '0',
          left: '4px',
          right: '4px',
          top: '0',
        },
        tabs: {
          bottom: '0',
          gap: '8px',
          left: '0',
          right: '0',
          top: '0',
        },
        textField: {
          left: '4px',
        },
      },
      radius: {
        radius: '0',
      },
    },
  },
  passwordInput: {
    default: {
      spacing: {
        bottom: '0',
        gap: '4px',
        left: '16px',
        right: '0',
        top: '0',
      },
    },
  },
  progressIndicator: {
    default: {
      circular: {
        color: {
          indicator: {
            live: '#0557d5',
            track: '#e6e6e6',
          },
          solid: {
            background: '#1a1a1a',
            indicator: {
              live: '#b3d1fe',
              track: '#666666',
            },
            text: '#ffffff',
          },
          transparent: {
            background: 'rgba(255,255,255,0)',
            indicator: {
              live: '#0557d5',
              track: '#d9d9d9',
            },
            text: '#333333',
          },
        },
        padding: {
          container: {
            bottom: '0',
            gap: '0',
            left: '0',
            right: '0',
            top: '0',
          },
          content: {
            bottom: '24px',
            gap: '8px',
            left: '24px',
            right: '24px',
            top: '24px',
          },
          indicator: {
            bottom: '0',
            gap: '0',
            left: '0',
            right: '0',
            top: '0',
          },
        },
        radius: {
          container: '4px',
          live: '9999px',
          track: '9999px',
        },
      },
      ids: {
        color: {
          indicator: {
            neutral: '#4d4d4d',
            oval1: '#0768fd',
            oval2: '#9e54b0',
            oval3: '#df216d',
            oval4: '#ff9300',
          },
          solid: {
            background: '#1a1a1a',
            text: '#ffffff',
          },
          transparent: {
            background: 'rgba(255,255,255,0)',
            text: '#333333',
          },
        },
        padding: {
          container: {
            bottom: '24px',
            gap: '8px',
            left: '24px',
            right: '24px',
            top: '24px',
          },
        },
        radius: {
          container: '4px',
        },
      },
      wrapper: {
        color: {
          scrim: {
            blurred: 'rgba(255,255,255,0.72)',
            solid: '#ffffff',
          },
        },
      },
    },
  },
  progressIndicatorDesignOnly: {
    default: {
      container: 'transparent',
      mode: 'default',
    },
  },
  radio: {
    default: {
      border: {
        control: '1px',
      },
      color: {
        control: {
          background: {
            selected: {
              disabled: 'rgba(5,87,213,0.48)',
              enabled: '#0557d5',
              focus: '#0557d5',
              hover: '#013d98',
              pressed: '#012865',
            },
            unselected: {
              disabled: 'rgba(5,87,213,0)',
              enabled: 'rgba(5,87,213,0)',
              focus: 'rgba(5,87,213,0)',
              hover: 'rgba(5,87,213,0.08)',
              pressed: 'rgba(5,87,213,0.16)',
            },
          },
          border: {
            disabled: 'rgba(128,128,128,0.48)',
            enabled: '#808080',
            focus: '#808080',
            hover: '#013d98',
            pressed: '#012865',
          },
          icon: {
            disabled: '#ffffff',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
        help: {
          enabled: '#4d4d4d',
        },
        label: {
          disabled: 'rgba(77,77,77,0.48)',
          enabled: '#333333',
          focus: '#333333',
          hover: '#1a1a1a',
          pressed: '#0d0d0d',
        },
        outline: '#001433',
      },
      radius: {
        control: '9999px',
        focus: {
          label: '4px',
          noLabel: '9999px',
        },
      },
      sizing: {
        control: {
          container: {
            height: '20px',
            width: '20px',
          },
          small: {
            height: '21px',
          },
          standard: {
            height: '24px',
          },
        },
        width: '16px',
      },
      spacing: {
        group: {
          horizontal: {
            gap: '12px',
            padding: '4px',
          },
          vertical: {
            gap: '12px',
            padding: '8px',
            small: {
              gap: '12px',
              padding: '8px',
            },
          },
        },
        small: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
        standard: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
    error: {
      border: {
        control: '2px',
      },
      color: {
        control: {
          background: {
            selected: {
              disabled: 'rgba(189,1,0,0.48)',
              enabled: '#bd0100',
              focus: '#bd0100',
              hover: '#990000',
              pressed: '#660000',
            },
            unselected: {
              disabled: 'rgba(189,1,0,0)',
              enabled: 'rgba(189,1,0,0)',
              focus: 'rgba(189,1,0,0)',
              hover: 'rgba(189,1,0,0.08)',
              pressed: 'rgba(189,1,0,0.16)',
            },
          },
          border: {
            disabled: 'rgba(189,1,0,0.48)',
            enabled: '#bd0100',
            focus: '#bd0100',
            hover: '#990000',
            pressed: '#660000',
          },
          icon: {
            disabled: '#ffffff',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
        help: {
          enabled: '#bd0100',
        },
        label: {
          disabled: 'rgba(77,77,77,0.48)',
          enabled: '#333333',
          focus: '#333333',
          hover: '#1a1a1a',
          pressed: '#0d0d0d',
        },
        outline: '#001433',
      },
      radius: {
        control: '9999px',
        focus: {
          label: '4px',
          noLabel: '9999px',
        },
      },
      sizing: {
        control: {
          container: {
            height: '20px',
            width: '20px',
          },
          small: {
            height: '21px',
          },
          standard: {
            height: '24px',
          },
        },
        width: '16px',
      },
      spacing: {
        group: {
          horizontal: {
            gap: '12px',
            padding: '4px',
          },
          vertical: {
            gap: '12px',
            padding: '8px',
            small: {
              gap: '12px',
              padding: '8px',
            },
          },
        },
        small: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
        standard: {
          bottom: '0',
          gap: '4px',
          left: '0',
          right: '0',
          top: '0',
        },
      },
    },
  },
  responsiveNavbar: {
    lg: {
      spacing: {
        sm: '4px',
      },
      width: {
        max: '1535px',
        min: '1200px',
      },
    },
    md: {
      spacing: {
        sm: '4px',
      },
      width: {
        max: '1199px',
        min: '900px',
      },
    },
    sm: {
      spacing: {
        sm: '4px',
      },
      width: {
        max: '899px',
        min: '600px',
      },
    },
    xl: {
      spacing: {
        sm: '8px',
      },
      width: {
        max: '2000px',
        min: '1536px',
      },
    },
    xs: {
      spacing: {
        sm: '2px',
      },
      width: {
        max: '599px',
        min: '320px',
      },
    },
  },
  segmentedControl: {
    default: {
      color: {
        background: {
          selected: {
            disabled: 'rgba(236,244,255,0.48)',
            enabled: '#b3d1fe',
            hover: '#cce0ff',
            pressed: '#ecf4ff',
          },
          unselected: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            hover: '#ecf4ff',
            pressed: '#cce0ff',
          },
        },
        border: {
          selected: {
            disabled: 'rgba(128,128,128,0.48)',
            enabled: '#808080',
            enabledHover: '#666666',
            enabledPressed: '#4d4d4d',
          },
          unselected: '#808080',
        },
        content: {
          selected: {
            disabled: 'rgba(5,87,213,0.48)',
            enabled: '#012865',
            hover: '#012865',
            pressed: '#0557d5',
          },
          unselected: {
            disabled: 'rgba(77,77,77,0.48)',
            enabled: '#0557d5',
            hover: '#013d98',
            pressed: '#012865',
          },
        },
        focus: {
          fill: 'rgba(255,255,255,0)',
          outline: '#001433',
          shadow: '#ecf4ff',
        },
      },
      radius: {
        container: '0',
        group: '4px',
      },
      sizing: {
        small: {
          minHeight: '32px',
          minWidth: '32px',
        },
        standard: {
          minHeight: '40px',
          minWidth: '40px',
        },
      },
      spacing: {
        small: {
          gap: '4px',
          horizontalPadding: '16px',
        },
        standard: {
          gap: '8px',
          horizontalPadding: '16px',
        },
      },
    },
    inverse: {
      color: {
        background: {
          selected: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            hover: '#f2f2f2',
            pressed: '#e6e6e6',
          },
          unselected: {
            disabled: 'rgba(77,77,77,0)',
            enabled: 'rgba(77,77,77,0)',
            hover: 'rgba(77,77,77,0.40)',
            pressed: 'rgba(77,77,77,0.56)',
          },
        },
        border: {
          selected: {
            disabled: 'rgba(230,230,230,0.48)',
            enabled: '#e6e6e6',
            enabledHover: '#d9d9d9',
            enabledPressed: '#cccccc',
          },
          unselected: '#e6e6e6',
        },
        content: {
          selected: {
            disabled: 'rgba(5,87,213,0.48)',
            enabled: '#0557d5',
            hover: '#013d98',
            pressed: '#012865',
          },
          unselected: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
        focus: {
          fill: 'rgba(255,255,255,0)',
          outline: '#001433',
          shadow: '#ecf4ff',
        },
      },
      radius: {
        container: '0',
        group: '4px',
      },
      sizing: {
        small: {
          minHeight: '32px',
          minWidth: '32px',
        },
        standard: {
          minHeight: '40px',
          minWidth: '40px',
        },
      },
      spacing: {
        small: {
          gap: '4px',
          horizontalPadding: '16px',
        },
        standard: {
          gap: '8px',
          horizontalPadding: '16px',
        },
      },
    },
    neutral: {
      color: {
        background: {
          selected: {
            disabled: 'rgba(77,77,77,0.48)',
            enabled: '#4d4d4d',
            hover: '#333333',
            pressed: '#1a1a1a',
          },
          unselected: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0.40)',
            pressed: 'rgba(255,255,255,0.56)',
          },
        },
        border: {
          selected: {
            disabled: 'rgba(128,128,128,0.48)',
            enabled: '#808080',
            enabledHover: '#666666',
            enabledPressed: '#4d4d4d',
          },
          unselected: '#4d4d4d',
        },
        content: {
          selected: {
            disabled: 'rgba(204,224,255,0.48)',
            enabled: '#b3d1fe',
            hover: '#cce0ff',
            pressed: '#ecf4ff',
          },
          unselected: {
            disabled: 'rgba(77,77,77,0.48)',
            enabled: '#333333',
            hover: '#1a1a1a',
            pressed: '#0d0d0d',
          },
        },
        focus: {
          fill: 'rgba(255,255,255,0)',
          outline: '#001433',
          shadow: '#ecf4ff',
        },
      },
      radius: {
        container: '0',
        group: '4px',
      },
      sizing: {
        small: {
          minHeight: '32px',
          minWidth: '32px',
        },
        standard: {
          minHeight: '40px',
          minWidth: '40px',
        },
      },
      spacing: {
        small: {
          gap: '4px',
          horizontalPadding: '16px',
        },
        standard: {
          gap: '8px',
          horizontalPadding: '16px',
        },
      },
    },
  },
  select: {
    default: {
      color: {
        background: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          focus: '#ffffff',
          hover: '#f2f2f2',
          pressed: '#ffffff',
        },
        border: {
          disabled: 'rgba(128,128,128,0.48)',
          enabled: '#808080',
          focus: '#808080',
          hover: '#666666',
          pressed: '#0557d5',
        },
        help: {
          disabled: 'rgba(77,77,77,0.48)',
          enabled: '#4d4d4d',
          focus: '#4d4d4d',
          hover: '#333333',
          pressed: '#1a1a1a',
        },
        input: {
          disabled: 'rgba(77,77,77,0.48)',
          enabled: '#333333',
          focus: '#333333',
          hover: '#1a1a1a',
          pressed: '#0d0d0d',
        },
        label: {
          disabled: 'rgba(77,77,77,0.48)',
          focus: '#333333',
          hover: '#1a1a1a',
          pressed: '#0d0d0d',
        },
      },
      outline: '#001433',
      radius: {
        small: '4px',
        standard: '4px',
      },
      sizing: {
        icon: {
          small: {
            height: '12px',
            width: '12px',
          },
          standard: {
            height: '16px',
            width: '16px',
          },
        },
      },
      spacing: {
        label: {
          padding: {
            bottom: '2px',
          },
        },
        small: {
          min: {
            height: '32px',
            width: '64px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            left: '8px',
            right: '8px',
            top: '4px',
          },
        },
        standard: {
          min: {
            height: '40px',
            width: '64px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            left: '12px',
            right: '8px',
            top: '4px',
          },
        },
      },
    },
    error: {
      color: {
        background: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          focus: '#ffffff',
          hover: '#f2f2f2',
          pressed: '#ffffff',
        },
        border: {
          disabled: 'rgba(189,1,0,0.48)',
          enabled: '#bd0100',
          focus: '#bd0100',
          hover: '#990000',
          pressed: '#660000',
        },
        help: {
          disabled: 'rgba(189,1,0,0.48)',
          enabled: '#bd0100',
          focus: '#bd0100',
          hover: '#990000',
          pressed: '#660000',
        },
        input: {
          disabled: 'rgba(77,77,77,0.48)',
          enabled: '#333333',
          focus: '#333333',
          hover: '#1a1a1a',
          pressed: '#0d0d0d',
        },
        label: {
          disabled: 'rgba(77,77,77,0.48)',
          focus: '#333333',
          hover: '#1a1a1a',
          pressed: '#0d0d0d',
        },
      },
      outline: '#001433',
      radius: {
        small: '4px',
        standard: '4px',
      },
      sizing: {
        icon: {
          small: {
            height: '12px',
            width: '12px',
          },
          standard: {
            height: '16px',
            width: '16px',
          },
        },
      },
      spacing: {
        label: {
          padding: {
            bottom: '2px',
          },
        },
        small: {
          min: {
            height: '32px',
            width: '64px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            left: '8px',
            right: '8px',
            top: '4px',
          },
        },
        standard: {
          min: {
            height: '40px',
            width: '64px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            left: '12px',
            right: '8px',
            top: '4px',
          },
        },
      },
    },
  },
  slider: {
    default: {
      color: {
        bar: {
          disabled: 'rgba(5,87,213,0.48)',
          enabled: '#0557d5',
        },
        handle: {
          border: {
            disabled: 'rgba(128,128,128,0.48)',
            enabled: '#808080',
            focus: '#808080',
            hover: '#0557d5',
            pressed: '#0557d5',
          },
          fill: {
            disabled: '#ffffff',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
        helpAndValueText: {
          default: '#333333',
          disabled: 'rgba(77,77,77,0.48)',
        },
        helpText: {
          disabled: 'rgba(77,77,77,0.48)',
          enabled: '#333333',
          focus: '#333333',
          hover: '#1a1a1a',
          pressed: '#0d0d0d',
        },
        label: {
          disabled: 'rgba(77,77,77,0.48)',
        },
        tickMark: {
          bar: {
            default: '#ffffff',
            disabled: 'rgba(255,255,255,0.48)',
          },
          track: {
            default: '#0557d5',
            disabled: 'rgba(5,87,213,0.48)',
          },
        },
        track: {
          border: {
            disabled: 'rgba(128,128,128,0.48)',
            enabled: '#808080',
          },
          disabled: 'rgba(230,230,230,0.48)',
          enabled: '#e6e6e6',
          fill: {
            disabled: 'rgba(246,247,251,0.48)',
            enabled: '#f6f7fb',
          },
        },
      },
      radius: {
        handle: '9999px',
        trackBar: '9999px',
      },
      shadow: {
        blur: '0',
        hover: 'rgba(5,87,213,0.10)',
        'hover-spread': '6px',
        hoverSpread: '6px',
        pressed: 'rgba(5,87,213,0.10)',
        'pressed-spread': '12px',
        pressedSpread: '12px',
        x: '0',
        y: '0',
      },
      sizing: {
        standard: {
          handle: {
            height: '20px',
            width: '20px',
          },
          track: {
            height: '8px',
          },
        },
        xl: {
          handle: {
            height: '32px',
            width: '32px',
          },
          track: {
            height: '12px',
          },
        },
      },
      spacing: {
        numberPicker: '0',
        standard: {
          field: {
            left: '4px',
          },
          gap: {
            continuous: '12px',
            discrete: '0',
            numberPicker: '24px',
          },
        },
        xl: {
          field: {
            left: '4px',
          },
          gap: {
            continuous: '12px',
            discrete: '0',
            numberPicker: '24px',
          },
        },
      },
    },
    error: {
      color: {
        bar: {
          disabled: 'rgba(230,230,230,0.48)',
          enabled: '#bd0100',
        },
        handle: {
          border: {
            disabled: 'rgba(128,128,128,0.48)',
            enabled: '#bd0100',
            focus: '#808080',
            hover: '#bd0100',
            pressed: '#bd0100',
          },
          fill: {
            disabled: '#ffffff',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
        helpAndValueText: {
          default: '#bd0100',
          disabled: 'rgba(189,1,0,0.48)',
        },
        helpText: {
          disabled: 'rgba(189,1,0,0.48)',
          enabled: '#bd0100',
          focus: '#bd0100',
          hover: '#990000',
          pressed: '#660000',
        },
        label: {
          disabled: 'rgba(77,77,77,0.48)',
        },
        tickMark: {
          bar: {
            default: '#ffffff',
            disabled: 'rgba(255,255,255,0.48)',
          },
          track: {
            default: '#0557d5',
            disabled: 'rgba(5,87,213,0.48)',
          },
        },
        track: {
          border: {
            disabled: 'rgba(128,128,128,0.48)',
            enabled: '#bd0100',
          },
          disabled: 'rgba(230,230,230,0.48)',
          enabled: '#e6e6e6',
          fill: {
            disabled: 'rgba(246,247,251,0.48)',
            enabled: '#f6f7fb',
          },
        },
      },
      radius: {
        handle: '9999px',
        trackBar: '9999px',
      },
      shadow: {
        blur: '0',
        hover: 'rgba(189,1,0,0.10)',
        'hover-spread': '6px',
        hoverSpread: '6px',
        pressed: 'rgba(189,1,0,0.10)',
        'pressed-spread': '12px',
        pressedSpread: '12px',
        x: '0',
        y: '0',
      },
      sizing: {
        standard: {
          handle: {
            height: '20px',
            width: '20px',
          },
          track: {
            height: '8px',
          },
        },
        xl: {
          handle: {
            height: '32px',
            width: '32px',
          },
          track: {
            height: '12px',
          },
        },
      },
      spacing: {
        numberPicker: '0',
        standard: {
          field: {
            left: '4px',
          },
          gap: {
            continuous: '12px',
            discrete: '0',
            numberPicker: '24px',
          },
        },
        xl: {
          field: {
            left: '4px',
          },
          gap: {
            continuous: '12px',
            discrete: '0',
            numberPicker: '24px',
          },
        },
      },
    },
  },
  splitButton: {
    default: {
      color: {
        border: {
          primary: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            transparent: 'rgba(255,255,255,0)',
          },
          secondary: {
            disabled: 'rgba(128,128,128,0.48)',
            enabled: '#808080',
          },
          tertiary: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            transparent: 'rgba(255,255,255,0)',
          },
        },
      },
      padding: {
        gap: '0',
      },
      radius: {
        button1: '0',
        button2: '0',
        button3: '0',
        button4: '0',
        buttonGroup: '4px',
      },
    },
  },
  stepper: {
    default: {
      color: {
        boxBorder: {
          disabled: 'rgba(230,230,230,0.48)',
          enabled: '#e6e6e6',
          focus: '#e6e6e6',
          hover: '#d9d9d9',
          pressed: '#cccccc',
        },
        completed: {
          box: {
            disabled: 'rgba(246,247,251,0.48)',
            enabled: '#f6f7fb',
            focus: '#f6f7fb',
            hover: '#eaecf6',
            pressed: '#dfe3f1',
          },
          divider: {
            disabled: 'rgba(5,87,213,0.48)',
            enabled: '#0557d5',
          },
          icon: {
            disabled: 'rgba(5,87,213,0.48)',
            enabled: '#0557d5',
            hover: '#013d98',
            pressed: '#012865',
          },
          path: {
            enabled: '#0557d5',
          },
          text: {
            disabled: 'rgba(77,77,77,0.48)',
            enabled: '#333333',
            focus: '#333333',
            hover: '#1a1a1a',
            pressed: '#0d0d0d',
          },
        },
        focusBorder: '#001433',
        inProgress: {
          box: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#eaecf6',
            pressed: '#dfe3f1',
          },
          icon: {
            disabled: 'rgba(5,87,213,0.48)',
            enabled: '#0557d5',
            hover: '#013d98',
            pressed: '#012865',
          },
          text: {
            disabled: 'rgba(77,77,77,0.48)',
            enabled: '#333333',
            focus: '#333333',
            hover: '#1a1a1a',
            pressed: '#0d0d0d',
          },
        },
        incomplete: {
          box: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#f2f2f2',
            pressed: '#e6e6e6',
          },
          divider: {
            disabled: 'rgba(77,77,77,0.48)',
            enabled: '#4d4d4d',
          },
          icon: {
            disabled: 'rgba(77,77,77,0.48)',
            enabled: '#4d4d4d',
            hover: '#333333',
            pressed: '#1a1a1a',
          },
          path: {
            enabled: '#cccccc',
          },
          text: {
            disabled: 'rgba(77,77,77,0.48)',
            enabled: '#333333',
            focus: '#333333',
            hover: '#1a1a1a',
            pressed: '#0d0d0d',
          },
        },
      },
      radius: {
        container: '4px',
        path: '9999px',
        pathStart: '9999px',
      },
      sizing: {
        box: {
          'max-height': '480px',
          'max-width': '480px',
          'min-height': '64px',
          'min-width': '64px',
        },
        horizontal: {
          max: {
            width: '160px',
          },
        },
        text: {
          max: {
            width: '480px',
          },
          min: {
            height: '48px',
            width: '48px',
          },
        },
      },
      spacing: {
        box: {
          bottom: '8px',
          gap: '8px',
          left: '12px',
          right: '16px',
          text: {
            bottom: '4px',
            top: '4px',
          },
          top: '8px',
        },
        boxGroup: {
          gap: '8px',
        },
        horizontal: {
          gap: '4px',
          gapNegative: '-8px',
          text: {
            side: '16px',
          },
        },
        vertical: {
          gap: '8px',
          path: {
            gap: '2px',
          },
          text: {
            bottom: '8px',
            right: '8px',
            top: '4px',
          },
        },
      },
    },
  },
  switch: {
    default: {
      color: {
        helpText: '#333333',
        off: {
          background: {
            disabled: 'rgba(128,128,128,0.48)',
            enabled: '#808080',
            focus: '#808080',
            hover: '#666666',
            pressed: '#4d4d4d',
          },
          handle: {
            disabled: '#ffffff',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
        on: {
          background: {
            disabled: 'rgba(5,87,213,0.48)',
            enabled: '#0557d5',
            focus: '#0557d5',
            hover: '#013d98',
            pressed: '#012865',
          },
          handle: {
            disabled: '#ffffff',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
        outline: '#001433',
      },
      radius: {
        container: '9999px',
        handle: '9999px',
      },
      sizing: {
        small: {
          switch: {
            height: '24px',
            width: '48px',
          },
        },
        standard: {
          switch: {
            height: '32px',
            width: '64px',
          },
        },
      },
      spacing: {
        small: {
          padding: {
            bottom: '4px',
            left: '4px',
            right: '4px',
            switchGap: '8px',
            textGap: '4px',
            top: '4px',
          },
        },
        standard: {
          padding: {
            bottom: '4px',
            left: '4px',
            right: '4px',
            switchGap: '8px',
            textGap: '4px',
            top: '4px',
          },
        },
      },
    },
  },
  table: {
    default: {
      background: '#ffffff',
      border: {
        color: '#e6e6e6',
        colorFrozen: '#4d4d4d',
        radius: '4px',
        stroke: '1px',
      },
      shadow: {
        blur: '16px',
        color: 'rgba(0,0,0,0.04)',
        default: {
          blur: '16px',
          color: 'rgba(0,0,0,0.04)',
          spread: '0',
          x: '0',
          y: '4px',
        },
        frozen: {
          blur: '20px',
          color: 'rgba(0,0,0,0.08)',
          spread: '0',
          x: '8px',
          y: '0',
        },
        spread: '0',
        x: '0',
        y: '4px',
      },
      shadowFrozen: {
        blur: '20px',
        color: 'rgba(0,0,0,0.08)',
        spread: '0',
        x: '8px',
        y: '0',
      },
      tableCell: {
        border: {
          control: {
            color: {
              editable: '#cccccc',
              enabled: '#e6e6e6',
              hover: '#d9d9d9',
            },
            stroke: '1px',
          },
          head: {
            color: {
              enabled: '#e6e6e6',
              hover: '#d9d9d9',
              selected: '#e6e6e6',
            },
            stroke: '1px',
          },
          text: {
            color: {
              editable: '#cccccc',
              enabled: '#e6e6e6',
              hover: '#d9d9d9',
              selected: '#0557d5',
            },
            stroke: '1px',
          },
          textSelected: {
            stroke: '1px',
          },
        },
        color: {
          control: {
            background: {
              editable: '#f6f7fb',
              enabled: '#ffffff',
              hover: '#ecf4ff',
            },
            label: {
              editable: '#0d0d0d',
              enabled: '#333333',
              hover: '#1a1a1a',
            },
          },
          head: {
            background: {
              enabled: '#f6f7fb',
              hover: '#eaecf6',
              selected: '#f6f7fb',
            },
            icon: {
              enabled: '#333333',
              hover: '#0557d5',
            },
            label: {
              enabled: '#333333',
              hover: '#1a1a1a',
              selected: '#0d0d0d',
            },
          },
          text: {
            background: {
              editable: '#f6f7fb',
              enabled: '#ffffff',
              hover: '#ecf4ff',
              selected: '#cce0ff',
            },
            label: {
              editable: '#0d0d0d',
              enabled: '#333333',
              hover: '#1a1a1a',
              selected: '#013d98',
            },
          },
        },
        minHeight: '48px',
        padding: {
          control: {
            firstChild: '8px',
            gap: '8px',
            horizontal: '4px',
            lastChild: '8px',
            vertical: '4px',
          },
          head: {
            firstChild: '12px',
            gap: '4px',
            horizontal: '4px',
            lastChild: '12px',
            vertical: '12px',
          },
          text: {
            firstChild: '8px',
            gap: '8px',
            horizontal: '4px',
            lastChild: '8px',
            vertical: '12px',
          },
        },
      },
      tableRowExpanded: {
        color: {
          background: '#f6f7fb',
          border: '#e6e6e6',
          label: '#333333',
        },
        padding: {
          editTop: '16px',
          gap: '32px',
          horizontal: '24px',
          vertical: '8px',
        },
      },
      tableToolbar: {
        color: {
          background: '#ffffff',
          label: '#333333',
        },
        padding: {
          gap: '8px',
          horizontal: '16px',
          vertical: '16px',
        },
      },
    },
  },
  tabs: {
    default: {
      color: {
        background: {
          box: {
            disabled: 'rgba(246,247,251,0.48)',
            enabled: '#f6f7fb',
            focus: '#f6f7fb',
            hover: '#eaecf6',
            pressed: '#dfe3f1',
          },
          disabled: 'rgba(255,255,255,0)',
          enabled: 'rgba(255,255,255,0)',
          focus: 'rgba(255,255,255,0)',
          hover: '#eaecf6',
          pressed: '#dfe3f1',
        },
        border: {
          disabled: 'rgba(230,230,230,0.48)',
          enabled: '#e6e6e6',
          focus: '#e6e6e6',
          hover: '#d9d9d9',
          nested: 'rgba(255,255,255,0)',
          pressed: '#cccccc',
          selected: {
            disabled: 'rgba(5,87,213,0.48)',
            enabled: '#0557d5',
            focus: '#001433',
            hover: '#013d98',
            pressed: '#012865',
          },
        },
        icon: {
          disabled: 'rgba(77,77,77,0.48)',
          enabled: '#4d4d4d',
          focus: '#4d4d4d',
          hover: '#333333',
          pressed: '#1a1a1a',
          selected: {
            enabled: '#333333',
            focus: '#333333',
            hover: '#1a1a1a',
            pressed: '#0d0d0d',
          },
        },
        label: {
          disabled: 'rgba(77,77,77,0.48)',
          enabled: '#4d4d4d',
          focus: '#4d4d4d',
          hover: '#333333',
          pressed: '#1a1a1a',
          selected: {
            enabled: '#333333',
            focus: '#333333',
            hover: '#1a1a1a',
            pressed: '#0d0d0d',
            sublabel: '#4d4d4d',
          },
        },
        outline: {
          focus: '#001433',
        },
      },
      radius: {
        horizontal: {
          bl: '0',
          bottomLeft: '0',
          bottomRight: '0',
          br: '0',
          tl: '4px',
          topLeft: '4px',
          topRight: '4px',
          tr: '4px',
        },
        vertical: {
          bl: '4px',
          bottomLeft: '4px',
          bottomRight: '0',
          br: '0',
          tl: '4px',
          topLeft: '4px',
          topRight: '0',
          tr: '0',
        },
      },
      sizing: {
        icon: {
          height: '20px',
          width: '20px',
        },
        min: {
          height: '40px',
          width: '40px',
        },
      },
      spacing: {
        padding: {
          bottom: '8px',
          gap: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
        tabList: {
          box: {
            bottom: '0',
            gap: '4px',
            left: '0',
            right: '0',
            top: '0',
          },
          line: {
            bottom: '0',
            gap: '0',
            left: '0',
            right: '0',
            top: '0',
          },
        },
      },
    },
  },
  tag: {
    default: {
      color: {
        background: {
          default: {
            accent: '#cc0077',
            brand: '#0557d5',
            danger: '#bd0100',
            decorative1: '#250056',
            decorative2: '#ff9300',
            decorative3: '#df216d',
            decorative4: '#0768fd',
            decorative5: '#9e54b0',
            neutral: '#4d4d4d',
            success: '#027815',
            warning: '#f0b323',
          },
          inverse: {
            accent: '#ffe5f4',
            brand: '#ecf4ff',
            danger: '#fcebeb',
            decorative1: '#f0e5ff',
            decorative2: '#fff4e5',
            decorative3: '#fce9f0',
            decorative4: '#e6f0ff',
            decorative5: '#f5eef7',
            neutral: '#e6e6e6',
            success: '#e5ffea',
            warning: '#fbecc8',
          },
        },
        content: {
          accent: '#cc0077',
          brand: '#0557d5',
          danger: '#bd0100',
          decorative1: '#0f0024',
          decorative2: '#995900',
          decorative3: '#861341',
          decorative4: '#013d98',
          decorative5: '#5e3069',
          neutral: '#ffffff',
          neutralInverse: '#333333',
          success: '#027815',
          warning: '#785800',
        },
        icon: '#ffffff',
        label: '#ffffff',
      },
      radius: '4px',
      sizing: {
        icon: {
          height: '12px',
          width: '12px',
        },
      },
      spacing: {
        min: {
          height: '20px',
          width: '20px',
        },
        padding: {
          bottom: '1px',
          gap: '4px',
          icon: {
            bottom: '0',
            gap: '0',
            left: '0',
            right: '0',
            top: '0',
          },
          left: '8px',
          right: '8px',
          top: '0',
        },
      },
    },
  },
  textArea: {
    default: {
      min: {
        minHeight: '56px',
        minWidth: '112px',
      },
    },
    error: {
      min: {
        minHeight: '56px',
        minWidth: '112px',
      },
    },
  },
  textField: {
    default: {
      color: {
        background: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          focus: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        border: {
          disabled: 'rgba(128,128,128,0.48)',
          enabled: '#808080',
          focus: '#0557d5',
          hover: '#0557d5',
          pressed: '#013d98',
        },
        help: {
          disabled: 'rgba(77,77,77,0.48)',
          enabled: '#4d4d4d',
          focus: '#4d4d4d',
          hover: '#333333',
          pressed: '#1a1a1a',
        },
        input: {
          disabled: 'rgba(77,77,77,0.48)',
          enabled: '#333333',
          focus: '#333333',
          hover: '#1a1a1a',
          pressed: '#0d0d0d',
        },
        label: {
          disabled: 'rgba(77,77,77,0.48)',
          focus: '#333333',
          hover: '#1a1a1a',
          pressed: '#0d0d0d',
        },
        outline: '#001433',
        placeholder: '#666666',
      },
      radius: {
        small: '4px',
        standard: '4px',
      },
      sizing: {
        icon: {
          small: {
            height: '12px',
            width: '12px',
          },
          standard: {
            height: '16px',
            width: '16px',
          },
        },
      },
      spacing: {
        label: {
          padding: {
            bottom: '2px',
          },
        },
        small: {
          min: {
            height: '32px',
            width: '40px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            left: '8px',
            leftSldsIcon: '28px',
            right: '8px',
            rightSldsIcon: '24px',
            top: '4px',
          },
        },
        standard: {
          min: {
            height: '40px',
            width: '40px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            left: '12px',
            leftSldsIcon: '36px',
            right: '8px',
            rightSldsIcon: '28px',
            top: '4px',
          },
        },
      },
    },
    error: {
      color: {
        background: {
          disabled: 'rgba(255,255,255,0.48)',
          enabled: '#ffffff',
          focus: '#ffffff',
          hover: '#ffffff',
          pressed: '#ffffff',
        },
        border: {
          disabled: 'rgba(189,1,0,0.48)',
          enabled: '#bd0100',
          focus: '#660000',
          hover: '#990000',
          pressed: '#660000',
        },
        help: {
          disabled: 'rgba(189,1,0,0.48)',
          enabled: '#bd0100',
          focus: '#bd0100',
          hover: '#990000',
          pressed: '#660000',
        },
        input: {
          disabled: 'rgba(77,77,77,0.48)',
          enabled: '#333333',
          focus: '#333333',
          hover: '#1a1a1a',
          pressed: '#0d0d0d',
        },
        label: {
          disabled: 'rgba(77,77,77,0.48)',
          focus: '#333333',
          hover: '#1a1a1a',
          pressed: '#0d0d0d',
        },
        outline: '#001433',
        placeholder: '#666666',
      },
      radius: {
        small: '4px',
        standard: '4px',
      },
      sizing: {
        icon: {
          small: {
            height: '12px',
            width: '12px',
          },
          standard: {
            height: '16px',
            width: '16px',
          },
        },
      },
      spacing: {
        label: {
          padding: {
            bottom: '2px',
          },
        },
        small: {
          min: {
            height: '32px',
            width: '40px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            left: '8px',
            leftSldsIcon: '28px',
            right: '8px',
            rightSldsIcon: '24px',
            top: '4px',
          },
        },
        standard: {
          min: {
            height: '40px',
            width: '40px',
          },
          padding: {
            bottom: '4px',
            gap: '8px',
            left: '12px',
            leftSldsIcon: '36px',
            right: '8px',
            rightSldsIcon: '28px',
            top: '4px',
          },
        },
      },
    },
  },
  textLink: {
    default: {
      color: {
        disabled: {
          icon: 'rgba(5,87,213,0.48)',
          text: 'rgba(5,87,213,0.48)',
        },
        enabled: {
          icon: '#0557d5',
          text: '#0557d5',
        },
        focus: {
          icon: '#0557d5',
          text: '#0557d5',
        },
        hover: {
          icon: '#013d98',
          text: '#013d98',
        },
        outline: '#001433',
        pressed: {
          icon: '#012865',
          text: '#012865',
        },
      },
      radius: {
        small: '4px',
        standard: '4px',
      },
      sizing: {
        icon: {
          small: {
            height: '12px',
            width: '12px',
          },
          standard: {
            height: '16px',
            width: '16px',
          },
        },
      },
      spacing: {
        padding: {
          small: {
            gap: '4px',
          },
          standard: {
            gap: '4px',
          },
        },
      },
    },
  },
  timePicker: {
    default: {
      color: {
        background: {
          now: '#f6f7fb',
        },
        border: {
          root: {
            disabled: 'rgba(128,128,128,0.48)',
            enabled: '#808080',
          },
        },
        text: {
          readOnly: '#4d4d4d',
        },
      },
    },
  },
  toast: {
    default: {
      color: {
        background: '#4d4d4d',
        border: 'rgba(255,255,255,0)',
        icon: '#ffffff',
        iconButton: {
          background: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focused: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0.08)',
            pressed: 'rgba(255,255,255,0.16)',
          },
          icon: {
            disabled: '#ffffff',
            enabled: '#ffffff',
            focused: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          outline: '#ffffff',
        },
        text: '#ffffff',
        textLink: {
          disabled: {
            icon: '#b3d1fe',
            text: '#b3d1fe',
          },
          enabled: {
            icon: '#b3d1fe',
            text: '#b3d1fe',
          },
          focused: {
            icon: '#b3d1fe',
            text: '#b3d1fe',
          },
          hover: {
            icon: '#cce0ff',
            text: '#cce0ff',
          },
          outline: '#b3d1fe',
          pressed: {
            icon: '#ecf4ff',
            text: '#ecf4ff',
          },
        },
      },
      radius: '4px',
      sizing: {
        icon: {
          height: '16px',
          width: '16px',
        },
        max: {
          width: '480px',
        },
        min: {
          height: '48px',
          width: '240px',
        },
      },
      spacing: {
        bottom: '12px',
        gap: '12px',
        icon: {
          bottom: '8px',
          gap: '0',
          left: '0',
          right: '0',
          top: '8px',
        },
        left: '16px',
        right: '16px',
        top: '12px',
      },
    },
    error: {
      color: {
        background: '#bd0100',
        border: 'rgba(255,255,255,0)',
        icon: '#ffffff',
        iconButton: {
          background: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focused: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0.08)',
            pressed: 'rgba(255,255,255,0.16)',
          },
          icon: {
            disabled: '#ffffff',
            enabled: '#ffffff',
            focused: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          outline: '#ffffff',
        },
        text: '#ffffff',
        textLink: {
          disabled: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          enabled: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          focused: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          hover: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          outline: '#ffffff',
          pressed: {
            icon: '#ffffff',
            text: '#ffffff',
          },
        },
      },
      radius: '4px',
      sizing: {
        icon: {
          height: '16px',
          width: '16px',
        },
        max: {
          width: '480px',
        },
        min: {
          height: '48px',
          width: '240px',
        },
      },
      spacing: {
        bottom: '12px',
        gap: '12px',
        icon: {
          bottom: '8px',
          gap: '0',
          left: '0',
          right: '0',
          top: '8px',
        },
        left: '16px',
        right: '16px',
        top: '12px',
      },
    },
    success: {
      color: {
        background: '#027815',
        border: 'rgba(255,255,255,0)',
        icon: '#ffffff',
        iconButton: {
          background: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focused: 'rgba(255,255,255,0)',
            hover: 'rgba(255,255,255,0.08)',
            pressed: 'rgba(255,255,255,0.16)',
          },
          icon: {
            disabled: '#ffffff',
            enabled: '#ffffff',
            focused: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
          outline: '#ffffff',
        },
        text: '#ffffff',
        textLink: {
          disabled: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          enabled: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          focused: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          hover: {
            icon: '#ffffff',
            text: '#ffffff',
          },
          outline: '#ffffff',
          pressed: {
            icon: '#ffffff',
            text: '#ffffff',
          },
        },
      },
      radius: '4px',
      sizing: {
        icon: {
          height: '16px',
          width: '16px',
        },
        max: {
          width: '480px',
        },
        min: {
          height: '48px',
          width: '240px',
        },
      },
      spacing: {
        bottom: '12px',
        gap: '12px',
        icon: {
          bottom: '8px',
          gap: '0',
          left: '0',
          right: '0',
          top: '8px',
        },
        left: '16px',
        right: '16px',
        top: '12px',
      },
    },
    warning: {
      color: {
        background: '#926b00',
        border: 'rgba(255,255,255,0)',
        icon: '#ffffff',
        iconButton: {
          background: {
            disabled: 'rgba(77,77,77,0)',
            enabled: 'rgba(77,77,77,0)',
            focused: 'rgba(77,77,77,0)',
            hover: 'rgba(77,77,77,0.08)',
            pressed: 'rgba(77,77,77,0.16)',
          },
          icon: {
            disabled: '#333333',
            enabled: '#333333',
            focused: '#333333',
            hover: '#1a1a1a',
            pressed: '#0d0d0d',
          },
          outline: '#333333',
        },
        text: '#ffffff',
        textLink: {
          disabled: {
            icon: '#333333',
            text: '#333333',
          },
          enabled: {
            icon: '#333333',
            text: '#333333',
          },
          focused: {
            icon: '#333333',
            text: '#333333',
          },
          hover: {
            icon: '#0d0d0d',
            text: '#1a1a1a',
          },
          outline: '#333333',
          pressed: {
            icon: '#0d0d0d',
            text: '#0d0d0d',
          },
        },
      },
      radius: '4px',
      sizing: {
        icon: {
          height: '16px',
          width: '16px',
        },
        max: {
          width: '480px',
        },
        min: {
          height: '48px',
          width: '240px',
        },
      },
      spacing: {
        bottom: '12px',
        gap: '12px',
        icon: {
          bottom: '8px',
          gap: '0',
          left: '0',
          right: '0',
          top: '8px',
        },
        left: '16px',
        right: '16px',
        top: '12px',
      },
    },
  },
  toggleButton: {
    default: {
      color: {
        SLDS: {
          selected: {
            background: {
              disabled: 'rgba(5,87,213,0.48)',
              enabled: '#0557d5',
              focus: '#013d98',
              hover: '#013d98',
              pressed: '#012865',
            },
            icon: {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              focus: '#ffffff',
              hover: '#ffffff',
              pressed: '#ffffff',
            },
          },
          unselected: {
            background: {
              disabled: 'rgba(5,87,213,0)',
              enabled: 'rgba(5,87,213,0)',
              focus: 'rgba(5,87,213,0.08)',
              hover: 'rgba(5,87,213,0.08)',
              pressed: 'rgba(5,87,213,0.16)',
            },
            border: {
              disabled: 'rgba(128,128,128,0.48)',
              enabled: '#808080',
              focus: '#666666',
              hover: '#013d98',
              pressed: '#012865',
            },
            icon: {
              disabled: 'rgba(77,77,77,0.48)',
              enabled: '#4d4d4d',
              focus: '#333333',
              hover: '#013d98',
              pressed: '#012865',
            },
          },
        },
        default: {
          background: {
            disabled: 'rgba(5,87,213,0)',
            enabled: 'rgba(5,87,213,0)',
            focus: 'rgba(5,87,213,0.08)',
            hover: 'rgba(5,87,213,0.08)',
            pressed: 'rgba(5,87,213,0.16)',
          },
          icon: {
            disabled: 'rgba(77,77,77,0.48)',
            enabled: '#4d4d4d',
            focus: '#333333',
            hover: '#333333',
            pressed: '#1a1a1a',
          },
        },
      },
      padding: {
        extraSmall: '2px',
        small: '4px',
        standard: '8px',
      },
      radius: '9999px',
      sizing: {
        extraSmall: {
          height: '24px',
          width: '24px',
        },
        small: {
          height: '32px',
          width: '32px',
        },
        standard: {
          height: '48px',
          width: '48px',
        },
      },
    },
    inverse: {
      color: {
        SLDS: {
          selected: {
            background: {
              disabled: 'rgba(5,87,213,0.48)',
              enabled: '#0557d5',
              focus: '#013d98',
              hover: '#013d98',
              pressed: '#012865',
            },
            icon: {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              focus: '#ffffff',
              hover: '#ffffff',
              pressed: '#ffffff',
            },
          },
          unselected: {
            background: {
              disabled: 'rgba(255,255,255,0)',
              enabled: 'rgba(255,255,255,0)',
              focus: 'rgba(255,255,255,0.08)',
              hover: 'rgba(255,255,255,0.08)',
              pressed: 'rgba(255,255,255,0.16)',
            },
            border: {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              focus: '#ffffff',
              hover: '#e6e6e6',
              pressed: '#d9d9d9',
            },
            icon: {
              disabled: 'rgba(255,255,255,0.48)',
              enabled: '#ffffff',
              focus: '#ffffff',
              hover: '#f2f2f2',
              pressed: '#e6e6e6',
            },
          },
        },
        default: {
          background: {
            disabled: 'rgba(255,255,255,0)',
            enabled: 'rgba(255,255,255,0)',
            focus: 'rgba(255,255,255,0.08)',
            hover: 'rgba(255,255,255,0.08)',
            pressed: 'rgba(255,255,255,0.16)',
          },
          icon: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#ffffff',
            pressed: '#ffffff',
          },
        },
      },
      padding: {
        extraSmall: '2px',
        small: '4px',
        standard: '8px',
      },
      radius: '9999px',
      sizing: {
        extraSmall: {
          height: '24px',
          width: '24px',
        },
        small: {
          height: '32px',
          width: '32px',
        },
        standard: {
          height: '48px',
          width: '48px',
        },
      },
    },
  },
  tooltip: {
    default: {
      color: {
        background: '#333333',
        border: '#4d4d4d',
        default: {
          background: {
            primary: '#000000',
            secondary: '#ffffff',
          },
          border: {
            secondary: '#808080',
          },
          label: {
            subtitle: {
              primary: '#ffffff',
              secondary: '#333333',
            },
          },
        },
        text: '#ffffff',
        title: {
          background: {
            primary: '#000000',
            secondary: '#ffffff',
          },
          border: {
            secondary: '#808080',
          },
          label: {
            subtitle: {
              primary: '#ffffff',
              secondary: '#333333',
            },
            title: {
              primary: '#ffffff',
              secondary: '#333333',
            },
          },
        },
      },
      radius: {
        radius: '4px',
      },
      sizing: {
        default: {
          min: {
            height: '24px',
            width: '24px',
          },
        },
        max: '480px',
        min: '32px',
        title: {
          min: {
            height: '64px',
            width: '48px',
          },
        },
      },
      spacing: {
        Number: '0',
        default: {
          bottom: '0',
          left: '8px',
          padding: {
            bottom: '4px',
            side: '8px',
            top: '4px',
          },
          right: '8px',
          top: '0',
        },
        title: {
          bottom: '8px',
          left: '16px',
          right: '16px',
          top: '8px',
        },
      },
    },
    inverse: {
      color: {
        background: '#ffffff',
        border: '#e6e6e6',
        text: '#333333',
        title: {
          label: {
            subtitle: {
              primary: '#ffffff',
            },
            title: {
              primary: '#ffffff',
            },
          },
        },
      },
      radius: {
        radius: '4px',
      },
      sizing: {
        max: '480px',
        min: '32px',
      },
      spacing: {
        default: {
          padding: {
            bottom: '4px',
            side: '8px',
            top: '4px',
          },
        },
      },
    },
  },
  treeView: {
    default: {
      color: {
        richHeader: '#f6f7fb',
        selected: {
          background: {
            disabled: 'rgba(236,244,255,0.48)',
            enabled: '#ecf4ff',
            focus: '#ecf4ff',
            hover: '#cce0ff',
            pressed: '#b3d1fe',
          },
          border: {
            disabled: 'rgba(5,87,213,0.48)',
            enabled: '#0557d5',
            focus: '#0557d5',
            hover: '#013d98',
            pressed: '#012865',
          },
        },
        text: {
          subtitle: {
            disabled: 'rgba(77,77,77,0.48)',
            enabled: '#4d4d4d',
            focus: '#4d4d4d',
            hover: '#333333',
            pressed: '#1a1a1a',
          },
          title: {
            disabled: 'rgba(77,77,77,0.48)',
            enabled: '#333333',
            focus: '#333333',
            hover: '#1a1a1a',
            hyperlink: '#0557d5',
            pressed: '#0d0d0d',
          },
        },
        unselected: {
          background: {
            disabled: 'rgba(255,255,255,0.48)',
            enabled: '#ffffff',
            focus: '#ffffff',
            hover: '#eaecf6',
            pressed: '#dfe3f1',
          },
          border: {
            enabled: '#e6e6e6',
          },
        },
      },
      padding: {
        small: {
          child: {
            bottom: '8px',
            gap: '8px',
            left: '48px',
            right: '24px',
            top: '8px',
          },
          parent: {
            bottom: '8px',
            gap: '8px',
            left: '16px',
            right: '24px',
            top: '8px',
          },
        },
        standard: {
          child: {
            bottom: '12px',
            gap: '8px',
            left: '52px',
            right: '24px',
            top: '12px',
          },
          parent: {
            bottom: '12px',
            gap: '8px',
            left: '16px',
            right: '24px',
            top: '12px',
          },
        },
      },
      radius: '0',
    },
  },
  typography: {
    default: {
      color: {
        default: {
          accent: '#cc0077',
          brand: '#0557d5',
          danger: '#bd0100',
          decorative1: '#0f0024',
          decorative2: '#995900',
          decorative3: '#861341',
          decorative4: '#013d98',
          decorative5: '#5e3069',
          neutral: '#333333',
          success: '#027815',
          warning: '#926b00',
        },
        inverse: {
          accent: '#ffe5f4',
          brand: '#ecf4ff',
          danger: '#fcebeb',
          decorative1: '#f0e5ff',
          decorative2: '#fff4e5',
          decorative3: '#fce9f0',
          decorative4: '#e6f0ff',
          decorative5: '#f5eef7',
          neutral: '#ffffff',
          success: '#e5ffea',
          warning: '#fbecc8',
        },
      },
      sizing: {
        icon: {
          lineHeight: {
            bodyDefault: '24px',
            bodySmall: '21px',
            caption: '20px',
            headline: '53px',
            subheadline: '35px',
            subtitle: '30px',
            title: '36px',
          },
        },
      },
      spacing: {
        gap: {
          bodyDefault: '8px',
          bodySmall: '4px',
          caption: '4px',
          headline: '12px',
          subheadline: '8px',
          subtitle: '8px',
          title: '8px',
        },
      },
    },
    font: {
      fallback: 'Noto Sans, Nunito Sans, Arial, sans-serif',
      family: 'Noto Sans',
      size: {
        '2x': '24px',
        '3x': '28px',
        '4x': '32px',
        '5x': '36px',
        '6x': '40px',
        '7x': '48px',
        '8x': '60px',
        base: '16px',
        lg: '18px',
        sm: '14px',
        xl: '20px',
        xs: '13px',
      },
      weight: {
        black: 900,
        bold: 700,
        heavy: 800,
        light: 300,
        medium: 500,
        regular: 400,
        semibold: 600,
        thin: 200,
      },
    },
    lineHeight: {
      '2x': '35px',
      '3x': '36px',
      '4x': '42px',
      '5x': '48px',
      '6x': '53px',
      '7x': '60px',
      '8x': '72px',
      base: '24px',
      lg: '27px',
      sm: '21px',
      xl: '30px',
      xs: '20px',
    },
    spacing: {
      letter: {
        '2x': '0.48px',
        '3x': '0.80px',
        '4x': '1.00px',
        '5x': '1.20px',
        '6x': '1.40px',
        base: '0.32px',
        lg: '0.32px',
        md: '0.28px',
        negative: {
          lg: '-0.48px',
          md: '-0.32px',
          sm: '-0.26px',
          xl: '-1.00px',
        },
        none: '0',
        sm: '0.26px',
        xl: '0.40px',
      },
      paragraph: {
        '2x': '52.80px',
        '3x': '54.00px',
        '4x': '63.00px',
        '5x': '72.00px',
        '6x': '79.20px',
        '7x': '90.00px',
        '8x': '108.00px',
        base: '36.00px',
        lg: '40.50px',
        none: '0',
        sm: '31.50px',
        xl: '45.00px',
        xs: '29.25px',
      },
    },
  },
  videoPlayer: {
    default: {
      radius: {
        container: '0',
        focus: '0',
      },
    },
  },
};
